const admin_local_cn = {
  refundreason: "退款原因",
      status_filter_placeholder: "状态",
      status_filter_all: "全部",
    entries_total: "{count} 个总条目在此发票上",
    entries_linked: "{count} 个已关联的产品代码在此供应商处在此发票上",
    entries_ignored: "{count} 个被忽略的产品代码在此供应商处在此发票上",
    entries_new: "{count} 个新产品代码在此供应商处在此发票上",
    status_draft: "草稿",
    status_new: "新",
    status_linked: "已关联",
    status_ignored: "已忽略",
    status_none: "无状态",
  cashier_day_close_requires_cash_register_report: "在创建收银机报表之前，无法创建日结报表。",
  cashier_day_close_failed: "日结未成功。当天仍处于开启状态。",
  cashier_day_closed: "收银机已关闭。",
  montax_not_enough_money_in_drawer: "收银机钱箱中的现金不足以完成此次付款，请联系工作人员。",
  cashier_day_open_reprint_receipt_question: "当天已经开业。是否下载并重新打印开业小票？",
  cashier_day_close_reprint_receipt_question: "当天已经闭业。是否下载并重新打印闭业小票？",
  cashier_day_reprint_download_failed: "无法下载上一日的开业/闭业小票用于重打。",
  cashier_day_close_history_button: "打印以往关班报告",
  cashier_day_close_history_title: "打印以往关班报告",
  cashier_day_close_history_select: "选择日期（财政日编号 - 日期）：",
  cashier_day_close_history_period: "请输入时间段（最多31天）：",
  cashier_day_close_history_from: "从：",
  cashier_fiscal_report_period: "请输入时间段：",
  cashier_fiscal_report_period_invalid: "时间段无效。开始日期不能晚于结束日期。",
  cashier_day_close_history_to: "到：",
  cashier_day_close_history_period_invalid: "时间段无效。开始日期不能晚于结束日期，且时间段最多31天。",
  cashier_day_close_history_empty: "所选时间段内未找到关班报告。",
  cashier_day_not_open: "财政日未开启。",
  cashier_not_enough_money_in_drawer: "钱箱中的现金不足。",
  cashier_cash_flow_invalid_input: "请选择原因并输入有效金额。",
  cashier_cash_flow_print_failed: "单据已创建，但打印失败。",
  menu_editor_texts: {
    options: "选项",
    mandatoryOptions: "必选项",
    includedOptions: "已包含选项",
    optionalAdditions: "可选加料",
    quantity: "数量",
    min: "最小",
    max: "最大",
    type: "类型",
    local: "堂食",
    takeaway: "外带",
    proportional: "按比例",
    enabled: "启用",
    disabled: "禁用",
    selected: "已选择",
    notSelected: "未选择",
    token: "标记",
    categoryAddition: "分类加项",
    menuitemAddition: "菜品加项",
    addedTo: "已添加到",
    removedFrom: "已从中移除",
    updatedIn: "已更新于",
    noTokenChanges: "没有标记变化",
    tokenOption: "标记选项",
    typeLabel: "类型",
    quantityLabel: "数量",
    minLabel: "最小",
    maxLabel: "最大",
    categoryTypeMultiple: "可多选",
    categoryTypeSeparate: "独立最小/最大",
    categoryTypeMaxOne: "最多一个",
    categoryTypeOne: "恰好一个",
    meal: "餐食",
    drink: "饮品"
  },
  _active: "激活",
  _add_category: "新类",
  _add_item: "新项目",
  _available: "可用",
  _available_quantity: "数量",
  _brutto_price: "毛价格",
  _brutto_unit_price: "毛单价",
  _category: "类别",
  _default_production_line: "默认生产线",
  _default_takeaway_vat_category: "外卖增值税",
  _default_vat_category: "增值税",
  _deleted: "已删",
  _discount: "折扣",
  _duration: "时长",
  _entry_count: "记录",
  _exchange_rate: "汇率",
  _from_store: "来源",
  _isInventoryItem: "库存物品",
  _isTop: "菜单",
  _item: "项目",
  _last_status: "最后状态",
  _multiplicator: "倍",
  _name: "名称",
  _net_price: "净价格",
  _net_unit_price: "净单价",
  _online: "在线",
  _option: "选项",
  _order_sequence_number: "订单号",
  _orders: "订单号",
  _paid_by: "已支付",
  _payment_method: "支付方式",
  _persons: "人",
  _production_line: "生产线",
  _profit_margin: "利润",
  _quantioty_type: "数量类型",
  _quantity: "数量",
  _quantity_type: "数量类型",
  _recalculateConsumption: "重新计算库存",
  _seqnr: "序号",
  _service_fee: "服务费",
  _settings: {
    business_day_ends_at: {
      description: "以小时计，可能少于开始时间，例如，营业日结束时间为凌晨五点",
      title: "营业日结束"
    },
    business_day_starts_at: {
      description: "以小时计",
      title: "营业日开始"
    },
    compulsory_service_fee: {
      description: "对于非现金收银台，自动应用服务费，可在打印发票前进行调整。",
      title: "强制服务费"
    },
    compulsory_service_fee_for_pos: {
      description: "对于收银机台，自动应用服务费。",
      title: "收银机强制服务费"
    },
    day: "天",
    days: ["星期一", "星期二", "星期三", "星期四", "星期五", "星期六", "星期日", "日期"],
    description_footer: {
      title: "网页商店底部内容"
    },
    description_header: {
      title: "网页商店头部内容"
    },
    drinks: {
      default: {
        description: "服务员和网页商店点餐时的默认饮料或餐点显示。",
        title: "默认"
      },
      enabled: {
        title: "启用"
      },
      label: {
        description: "在网页商店上显示的标签。",
        title: "标签"
      },
      title: "设置: 饮料"
    },
    email: "电子邮件地址",
    en: "英语",
    enabled_features: {
      homedelivery: {
        allowed_installments: {
          by_each: "每日付款",
          description: "菜单订单的分期付款选项",
          end: "最后付款",
          start: "预付款",
          title: "分期付款选项"
        },
        autoclose: {
          description: "自动关闭已支付和已交付的订单",
          title: "自动关闭"
        },
        "available-timeslots": {
          description: "这些时间段可供网页商店配送使用",
          title: "送货时间段"
        },
        blockWaiterClose: {
          description: "只有管理员可以关闭家庭送货",
          title: "阻止服务员关闭"
        },
        copy_order_email: {
          description: "谁应该收到有关网页商店订单和状态变更的电子邮件通知",
          title: "电子邮件通知"
        },
        dayends: {
          description: "在网页商店中，最多可以到什么时间下单以便当天送达",
          title: "日终时间"
        },
        delays: {
          description: "为Wolt/Foodpanda确认的准备/送货时间（以分钟为单位）",
          title: "预计送达时间"
        },
        encode_seqnr: {
          description: "为客户加密订单号",
          title: "秘密订单号"
        },
        homedelivery_menuitem: {
          description: "在应用邮政编码基础的送货费时，系统使用哪个产品。如果该产品尚未存在，请创建一个名为“家庭送货费”的新产品，保存后重新打开编辑，记下其ID并在此处输入。",
          title: "首页配送费用的产品ID"
        },
        instantOrderOnly: {
          description: "仅接受网页商店中的即时订单",
          title: "仅限即时订单"
        },
        "min-duration": {
          description: "送达时间段的持续时间（以小时为单位）",
          title: "送达时间段持续时间"
        },
        orderedStatus: {
          description: "网页商店中订单商品的初始状态",
          title: "订单后状态"
        },
        phone_order_fee: {
          description: "电话订单的系统使用费",
          title: "系统使用费"
        },
        price: {
          above_amount: "金额大于",
          area: {
            description: "在地图上绘制送货区域",
            title: "地图"
          },
          courierFee: {
            description: "外卖配送的快递费",
            title: "快递费"
          },
          description: "您可以选择根据邮政编码和订单金额自动收取送货费",
          except: {
            description: "排除带标签的产品",
            title: "除外"
          },
          name: "名称",
          only: {
            description: "仅限带标签的产品",
            title: "仅限"
          },
          price: "送货费用",
          title: "送货费用",
          zip: "邮政编码"
        },
        printInvoiceOnOrder: {
          description: "新订单提交后自动打印发票",
          title: "自动打印发票"
        },
        printAllLabels: {
          description: "在家庭配送占用选择器中显示批量打印所有标签的按钮。",
          title: "打印所有配送标签"
        },
        send_email_on: {
          description: "当网页商店订单达到哪个状态时，向上述地址发送电子邮件通知",
          title: "状态变更时发送电子邮件"
        },
        "table-number": {
          description: "处理家庭送货订单时的桌号",
          title: "桌号"
        },
        "terms-and-conditions": {
          description: "在下单时向客户说明家庭配送条件",
          title: "通用条款与条件"
        },
        timeahead: {
          description: "对于手动或网页商店订单，您最多提前多少小时保证送达",
          title: "提前时间"
        },
        user_allowed_installments: {
          by_each: "每日付款",
          description: "网页商店菜单订单的分期付款选项",
          end: "最后付款",
          start: "预付款",
          title: "网页商店的分期付款选项"
        },
        webshop_order_fee: {
          description: "网页商店订单的系统使用费",
          title: "系统使用费"
        },
        zip: {
          description: "系统接受哪些邮政编码（正则表达式）",
          title: "邮政编码"
        }
      },
      pickup: {
        allowed_installments: {
          by_each: "每日付款",
          description: "菜单订单的分期付款选项",
          end: "最后付款",
          start: "预付款",
          title: "分期付款选项"
        },
        autoclose: {
          description: "自动关闭已支付和已交付的订单",
          title: "自动关闭"
        },
        "available-timeslots": {
          description: "这些时间段可供网页商店取餐使用",
          title: "取餐时间段"
        },
        copy_order_email: {
          description: "谁应该收到有关网页商店订单和状态变更的电子邮件通知",
          title: "电子邮件通知"
        },
        dayends: {
          description: "在网页商店中，最多可以到什么时间下单以便当天取餐",
          title: "日终时间"
        },
        delays: {
          description: "为Wolt/Foodpanda确认的准备时间（以分钟为单位）",
          title: "预计取餐时间"
        },
        encode_seqnr: {
          description: "为客户加密订单号",
          title: "秘密订单号"
        },
        instantOrderOnly: {
          description: "仅接受网页商店中的即时订单",
          title: "仅限即时订单"
        },
        "min-duration": {
          description: "取餐时间段的持续时间（以小时为单位）",
          title: "取餐时间段持续时间"
        },
        orderedStatus: {
          description: "网页商店中订单商品的初始状态",
          title: "订单后状态"
        },
        phone_order_fee: {
          description: "电话订单的系统使用费",
          title: "系统使用费"
        },
        send_email_on: {
          description: "当网页商店订单达到哪个状态时，向上述地址发送电子邮件通知",
          title: "状态变更时发送电子邮件"
        },
        "table-number": {
          description: "处理取餐订单时的桌号",
          title: "桌号"
        },
        "terms-and-conditions": {
          description: "在下单时向客户说明取餐订单条件",
          title: "通用条款与条件"
        },
        timeahead: {
          description: "对于手动或网页商店订单，您最多提前多少小时保证订单准备",
          title: "提前时间"
        },
        user_allowed_installments: {
          by_each: "每日付款",
          description: "网页商店菜单订单的分期付款选项",
          end: "最后付款",
          start: "预付款",
          title: "网页商店的分期付款选项"
        },
        webshop_order_fee: {
          description: "网页商店订单的系统使用费",
          title: "系统使用费"
        }
      },
      prebooking: {
        bookingDelay: {
          description: "只能在当前时间之后的这段时间内进行预定",
          title: "预定提前时间"
        },
        defaultBookingMinutes: {
          description: "在网页商店上进行预定时的默认持续时间（以分钟为单位）",
          title: "网页商店的默认持续时间"
        },
        defaultDuration: {
          description: "预定时的默认持续时间（以分钟为单位）",
          title: "默认持续时间"
        },
        maxBookingMinutes: {
          description: "网页上预定的最长时间（以分钟为单位）",
          title: "最大预定时间"
        },
        maxLateDuration: {
          description: "允许的宽限时间（以分钟为单位），超过此时间未到达的预定将被删除",
          title: "允许的迟到时间"
        },
        minBookingMinutes: {
          description: "网页上预定的最短时间（以分钟为单位）",
          title: "最低预定时间"
        },
        openingHours: {
          description: "网页上的营业时间",
          slots: {
            description: "营业时间的时间段（例如，从10:00到14:00）",
            title: "时间段"
          },
          title: "营业时间"
        },
        seats: {
          description: "这些人数可以在网页上选择",
          title: "人数"
        },
        showBefore: {
          description: "在地面平面图上提前多少分钟显示预定",
          title: "提前显示时间"
        },
        slotMinutes: {
          description: "这些持续时间可以在网页上选择",
          title: "持续时间"
        }
      },
      pos: {
        customerScreenButton: {
          title: "顾客屏幕功能",
          enabled: {
            title: "顾客屏幕按钮",
            description: "在POS中启用顾客屏幕按钮。"
          }
        },
        askForTipOnCardPayment: {
          title: "银行卡支付时询问小费",
          description: "银行卡支付时，若已启用刷卡终端集成，则在顾客屏幕上询问小费。"
        },
        askForTipOnAllPayment: {
          title: "所有支付方式都询问小费",
          description: "对所有支付方式（包括现金）都在顾客屏幕上询问小费。"
        },
        askForTipOnAnyCardPayment: {
          title: "任意银行卡支付都询问小费",
          description: "对于任意银行卡支付方式都在顾客屏幕上询问小费，即使未启用终端集成。"
        },
        askForTipOnCashPayment: {
          title: "现金支付时询问小费",
          description: "使用现金支付时，在顾客屏幕上询问小费。"
        },
        mandatoryAskForTipOnCardPayment: {
          title: "支付时必须选择小费",
          description: "支付时必须在顾客屏幕上选择小费，不能通过双击支付按钮跳过。"
        },
        multiLogin: {
          title: "POS多用户同时登录",
          description: "允许多个用户在POS中同时保持登录状态。"
        },
        payFirst: {
          title: "先付款",
          description: "要求先付款后出单/履约。"
        },
        dontUnlock: {
          title: "付款后不自动解锁桌台",
          description: "付款后不要自动解锁桌台。"
        },
        tips: {
          title: "小费百分比选项",
          description: "在顾客屏幕上显示的预设小费百分比选项。"
        }
      }
    },
    from_hour: "起始小时",
    fromday: "起始日期",
    hu: "匈牙利语",
    meals: {
      default: {
        description: "服务员和网页商店点餐时的默认饮料或餐点显示。",
        title: "默认"
      },
      enabled: {
        title: "启用"
      },
      label: {
        description: "在网页商店上显示的标签。",
        title: "标签"
      },
      title: "设置: 餐点"
    },
    menu: {
      show_category_image: {
        title: "显示产品类别图片"
      },
      show_menuitem_image: {
        title: "显示产品图片"
      },
      title: "点餐界面，产品选择器"
    },
    minute: "分钟",
    payment_method: {
      meth: {
        title: "方式"
      },
      term: {
        description: "网页商店的支付条款",
        title: "支付条款"
      },
      title: "可用支付方式"
    },
    price_calculations: {
      increase_price: {
        above: {
          description: "如果新价格比原价高了指定的百分比或金额，则涨价。举例来说，0%意味着任何涨价都会生效。",
          dscription: "如果新价格比原价高了指定的百分比或金额，则涨价。举例来说，0%意味着任何涨价都会生效。",
          title: "涨价条件"
        },
        measure: {
          title: "计量类型"
        },
        title: "涨价逻辑"
      },
      lower_price: {
        above: {
          description: "如果新价格比原价低了指定的百分比或金额，则降价。举例来说，100%意味着任何降价都会生效。",
          dscription: "如果新价格比原价低了指定的百分比或金额，则降价。举例来说，100%意味着任何降价都会生效。",
          title: "降价条件"
        },
        description: "默认的组件/选项可以在下单时被移除/禁用或替换。",
        measure: {
          title: "计量类型"
        },
        title: "降价逻辑"
      },
      rounding: {
        description: "例如，1 -> 四舍五入到最接近的整数，50 -> 四舍五入到50或100。",
        title: "四舍五入"
      },
      title: "价格计算逻辑"
    },
    printing: {
      invoice: {
        title: "发票布局"
      },
      showAllComments: {
        description: "默认情况下，仅显示修改成本的评论。",
        title: "在发票上显示所有评论"
      },
      showOrderNumber: {
        description: "默认情况下适用于现金订单。",
        title: "在常规桌子上显示订单号"
      },
      title: "打印设置"
    },
    qrstart: {
      description: "将二维码放在发票开头",
      title: "二维码位置"
    },
    qstart: {
      description: "在发票开头显示二维码",
      title: "二维码位置"
    },
    register_tip: {
      description: "如果支付金额超过应付金额，注册差额作为小费。",
      title: "注册小费"
    },
    service_fee: {
      description: "例如，如果通常应用12%的服务费，填写12。服务费的应用和费率可在发票打印时设置或调整。",
      title: "服务费"
    },
    serviceVat: {
      description: "在发票/收据上按增值税类别分开显示服务费。",
      title: "分开服务费"
    },
    states: ["已删除", "已选择", "已下单", "已确认", "进行中", "准备中", "配送中", "已交付"],
    tables_overview: {
      title: "桌面概览操作"
    },
    "tables-overview": {
      always_allow_delete: {
        description: "即使是服务员权限也允许删除",
        title: "允许删除"
      },
      askPersonCount: {
        description: "占用桌子时请求客人数量以确定购物车大小",
        title: "请求人数"
      },
      "auto-table-qrcode": {
        description: "随着第一笔订单的打印，自动打印二维码",
        title: "自动打印二维码"
      },
      autoDeliverOnUnlock: {
        description: "释放桌子后，任何未删除的项目将自动设置为‘已交付’状态，并从库存中扣除",
        title: "自动交付模式"
      },
      autolock: {
        description: "设置时间后，屏幕会锁定，并且只能通过密码或密码解锁。",
        title: "自动屏幕锁定"
      },
      bigAdditions: {
        description: "厨房收据上的大号+/-行",
        title: "厨房收据上的大号字体"
      },
      bigOrderNumber: {
        description: "在厨房收据上打印比默认设置更大的订单号",
        title: "大号订单号"
      },
      block_waiter_print_daily_closing: {
        description: "禁止服务员查询当前流量数据",
        title: "禁止快速流量数据"
      },
      block_waiter_print_invoice: {
        description: "阻止服务员打印发票",
        title: "阻止打印发票"
      },
      block_waiter_register_payment: {
        description: "阻止服务员登记支付",
        title: "阻止登记支付"
      },
      delayed_orders_browser: {
        description: "订单只有在确认后才会发送到服务器。",
        title: "来自浏览器的延迟订单提交"
      },
      delayed_orders_mobile: {
        description: "订单只有在确认后才会发送到服务器。",
        title: "来自移动应用的延迟订单提交"
      },
      doubleWide: {
        description: "",
        title: "双倍宽厨房收据字体"
      },
      drinkOrderStatus: {
        description: "",
        title: "点饮品时的订单状态"
      },
      extra_charge_on_takeaway: {
        description: "在收银台或网页商店的外卖订单上自动添加额外费用",
        title: "外卖订单的额外费用"
      },
      hideMenuCategoryImage: {
        description: "在点餐屏幕上隐藏类别图片",
        title: "隐藏类别图片"
      },
      hideMenuItemImage: {
        description: "在点餐屏幕上隐藏产品图片",
        title: "隐藏产品图片"
      },
      kitchenQrCode: {
        description: "二维码可用于在使用相应的二维码阅读器扫描时进行厨房/酒吧订单报告",
        title: "在厨房/酒吧收据上打印二维码"
      },
      lessKioskButtons: {
        description: "在现金注册模式中显示最少的按钮",
        title: "现金注册模式中的按钮更少"
      },
      mealOrderStatus: {
        description: "",
        title: "点餐时的订单状态"
      },
      newOrdersKioskStatesShown: {
        description: "在现金注册模式下显示哪些状态（列）",
        title: "现金注册模式下显示的状态"
      },
      newOrdersStatesShown: {
        description: "新订单录入时显示哪些状态（列）",
        title: "新订单录入时显示的状态"
      },
      "notify-customer-when-part-ready": {
        description: "当一道菜在多个生产线准备时，即使不是所有生产线都准备好了，也要通知顾客",
        title: "当部分菜品准备好时通知顾客"
      },
      "notify-waiter-when-part-ready": {
        description: "当一道菜在多个生产线准备时，即使不是所有生产线都准备好了，也要通知服务员",
        title: "当部分菜品准备好时通知服务员"
      },
      perPersonKitchenReceipt: {
        description: "例如，当每个人的订单需要单独端送时",
        title: "每人分开的厨房收据"
      },
      pos_delayed_orders_browser: {
        description: "订单只有在确认后才会发送到服务器。",
        title: "POS模式下来自浏览器的延迟订单提交"
      },
      pos_delayed_orders_mobile: {
        description: "订单只有在确认后才会发送到服务器。",
        title: "POS模式下来自移动应用的延迟订单提交"
      },
      print_accepted_customer_orders: {
        description: "在确认后自动打印网店订单",
        title: "确认后自动打印"
      },
      states: {
        description: "考虑哪些订单状态",
        title: "筛选状态"
      },
      statesShown: {
        description: "打开桌面时显示哪些状态（列）",
        title: "显示的状态"
      },
      "table-qrcode": {
        description: "",
        enumNames: ["无", "仅支付", "连接"],
        title: "桌面打印二维码的功能"
      },
      timeout: {
        description: "屏幕应在多少秒后锁定",
        title: "锁定延迟"
      },
      unlockOnPayment: {
        description: "如果没有未付款项，支付后自动释放桌子",
        title: "自动释放"
      },
      waiter_print_daily_closing_full: {
        description: "为服务员提供完整的当前流量数据",
        title: "完整的快速流量数据"
      }
    },
    takeaway: {
      containerChargeItem: {
        title: "押金产品标识符"
      },
      default: {
        description: "为收银台启用自动外卖",
        title: "默认"
      },
      enabled: {
        title: "启用"
      },
      packageChargeItem: {
        title: "包装产品标识符"
      },
      price: {
        description: "在产品页面上指定额外的外卖价格选项。",
        title: "单独外卖价格"
      },
      systemFeeItem: {
        title: "系统使用费产品标识符"
      },
      title: "外卖",
      vat: {
        title: "外卖默认增值税"
      }
    },
    timezone: {
      title: "时区"
    },
    timings: {
      enabled: {
        title: "启用"
      },
      enabled_online: {
        title: "启用网页商店的现场订单"
      },
      langs: {
        lang: {
          title: "语言"
        },
        name: {
          title: "标签"
        },
        name_online: {
          title: "网页商店上的标签"
        },
        title: "语言标签"
      },
      title: "课程"
    },
    to_hour: "结束小时",
    today: "结束日期"
  },
  _split_invoice: "拆分",
  _supplier_code: "供应商代码",
  _tip: "小费",
  _to_store: "目标",
  _top_category: "顶级类",
  _unit_price: "价格",
  _vat_category: "增值税",
  accept_homedelivery_terms: "我同意家庭送货条款",
  accept_pickup_terms: "我同意自取条款",
  accept_privacy_terms: "我接受隐私政策",
  "Access denied": "访问被拒绝",
  access_denied: "访问被拒绝：{0}",
  access_tokens: "访问令牌",
  action_failed: "操作失败。可能是某些内容未更新；让我们同步并再次尝试操作！",
  action_not_allowed: "您没有执行此操作的权限",
  activate: "激活",
  activate_booking: "激活预订",
  activate_sound: "铃声已激活",
  active: "激活",
  active_average_acceptance_duration: "平均订单接受时间",
  active_average_delivering_duration: "平均订单配送时间",
  active_max_acceptance_duration: "最高订单接受时间",
  active_max_delivering_duration: "最高订单配送时间",
  active_min_acceptance_duration: "最低订单接受时间",
  active_min_delivering_duration: "最低订单配送时间",
  add: "添加",
  add_category: "新类别",
  add_item: "新项目",
  add_meal: "新餐点",
  add_meal_category: "新类别",
  add_option: "新选项",
  add_role: "新增角色",
  add_room: "添加房间",
  add_user: "新增用户",
  addlogin: "添加额外用户登录",
  address: "地址",
  address_pattern: "^.+ (street|square|park) \\d+\\.?$",
  address_pattern2: "[^,].+ (hrsz|arok|atjaro|dulo|dulout|erdosor|fasor|fordulo|gat|hatarsor|határút|kapu|körönd|körtér|körút|köz|lakótelep|lejáró|lejtő|lépcső|liget|mélyút|orom|ösvény|park|part|pincesor|rakpart|sétány|sikátor|sor|sugárút|tér|udvar|ut|utca|üdülőpart)",
  address_placeholder: "格式：名称 (街道|广场|等) 编号。",
  afterPrint: "打印后",
  agree: "提供我的同意",
  alias: "全局 ID",
  all: "全部",
  all_items: "所有",
  all_production_lines: "所有生产线",
  allergens: "过敏原",
  allergens_tooltip: "<div class='allergen-gluten'>产品不含该过敏原</div><div class='allergen-gluten has'>产品含有该过敏原</div><div class='allergen-gluten inherited'>产品通过继承或配方包含该过敏原</div><div class='allergen-gluten has removable'>产品可以在制作时去除该过敏原</div>",
  allowed_installments: {
    by_each: "每日",
    end: "结束时",
    start: "预付款"
  },
  already_paid_reprint_invoice: "账单已结清！您真的想重新打印发票吗？",
  ambience: "氛围",
  amount: "金额",
  amount_paid: "已支付",
  amount_to_pay: "应付金额",
  ap: "AP号",
  apply_type_discount: "应用折扣",
  "Are you sure you want to change for a different customer? The new email is different to the already given one!": "您确定要更改为不同的客户吗？新的电子邮件与已给出的电子邮件不同！",
  "Are you sure you want to change for a different customer? The new phone number is different to the already given one!": "您确定要更改为不同的客户吗？新的电话号码与已给出的电话号码不同！",
  are_you_sure_you_cancel_the_payment: "您确定要取消支付详情注册吗?",
  are_you_sure_you_want_to_delete: "您确定要删除",
  are_you_sure_you_want_to_delete_the_cashregister: "您确定要删除收银机 <b>{0}</b> 吗?",
  are_you_sure_you_want_to_delete_the_discount_type: "您确定要删除折扣类型 <b>{0}</b> 吗?",
  are_you_sure_you_want_to_delete_the_floorplan: "您确定要删除楼层图 <b>{0}</b> 吗？",
  are_you_sure_you_want_to_delete_the_incoming_stock: "您确定要删除选中的入库记录吗？",
  are_you_sure_you_want_to_delete_the_inventory: "您确定要删除选中的库存记录吗？",
  are_you_sure_you_want_to_delete_the_label: "您确定要删除标签 <b>{0}</b> 吗？",
  are_you_sure_you_want_to_delete_the_printer: "您确定要删除打印机 <b>{0}</b> 吗?",
  are_you_sure_you_want_to_delete_the_production_line: "您确定要删除标签 <b>{0}</b> 吗？",
  are_you_sure_you_want_to_delete_the_quantity_type: "您确定要删除服务 <b>{0}</b> 吗?",
  are_you_sure_you_want_to_delete_the_room: "您确定要删除 <b>房间 {0}</b> 吗？",
  are_you_sure_you_want_to_delete_the_store: "您确定要删除商店 <b>{0}</b> 吗？",
  are_you_sure_you_want_to_delete_the_table: "您确定要删除 <b>桌子 {0}</b> 吗？",
  are_you_sure_you_want_to_delete_the_vat_category: "您确定要删除增值税类别 <b>{0}</b> 吗?",
  are_you_sure_you_want_to_delete_traffic_until: "您确定要删除直到 <strong>{0}</strong> 的流量吗？",
  assign_to_me: "分配给我",
  assistance_needed: "叫服务员",
  authenticate: "认证",
  authenticate_gba: "认证谷歌商业资料",
  auto_commit_imcoming_stocks: "自动提交",
  auto_commit_incoming_stocks_tooltip: "根据供应商的到货发票自动生成最终（非草稿）库存条目，并即时更新库存。",
  auto_import_incoming_stocks: "自动入库",
  auto_import_incoming_stocks_tooltip: "根据供应商的到货发票自动生成库存条目。",
  auto_translate: "自动翻译",
  automatic: "自动",
  available: "可用",
  available_quantity: "可用数量",
  availability_enabled_hint: "该商品已重新可用。它可再次显示在 Wolt/Foodora、自助点餐机和 webshop 平台上。",
  availability_disabled_hint: "该商品现已不可用。它可能会在 Wolt/Foodora、自助点餐机和 webshop 平台上被隐藏。",
  tabledisplay_link_button: "绑定桌面显示器",
  tabledisplay_scan_unavailable: "此设备不支持二维码扫描。",
  tabledisplay_scan_invalid: "扫描到的二维码不包含有效的显示器ID。",
  tabledisplay_scan_failed: "显示器二维码扫描失败。",
  tabledisplay_link_success: "桌面显示器已绑定：{0} -> {1}（模板：{2}）。",
  tabledisplay_link_failed: "无法为扫描到的显示器创建并绑定ESL商品。",
  averageCost: "平均成本",
  averagePrice: "平均价格",
  back: "返回",
  backup: "备份",
  backup_url: "备份URL",
  barcode: "条形码",
  barcode_found_but_no_menuitem: "条形码已找到，但系统中没有关联的本地产品。",
  barcode_not_found: "未知的条形码！",
  basic_data: "基本数据",
  below_criticalStock: "产品低于临界数量，危及业务运营",
  below_minimumStock: "产品低于最小数量，通常会进行补货",
  bizpay: {
    error: {
      unknown: "银行卡支付失败"
    }
  },
  book_a_table: {
    not_enough_free_tables: "没有足够的空桌子！",
    not_free_table: "没有空桌子！",
    number_of_seats: "{0} 个座位",
    provide_comment: "评论",
    provide_email: "电子邮件",
    provide_name: "姓名",
    provide_name_or_email: "输入客人姓名或电子邮件",
    provide_phone: "电话号码",
    room: "房间",
    rooms: "房间",
    seats: "座位",
    tables: "桌子",
    title: "预定桌子"
  },
  book_online: "可供客人预订",
  booking_comment: "备注",
  brutto_income: "总收入",
  brutto_price: "毛价格",
  brutto_unit_price: "毛单价",
  by_drink_or_meal_tab: "按餐品或饮料",
  by_occupation_start: "按订单时间",
  by_payment: "按支付时间",
  by_person_tab: "按人",
  by_timing_tab: "按时间",
  calendar: "日历",
  calorie: "卡路里",
  cancel: "取消",
  cancel_b: "取消",
  cancel_booking: "取消预订",
  cancel_paying: "取消账单",
  cancelled_orders: "已删除",
  cartsize: "购物车大小",
  cashier: "收银员",
  cashier_dayclose: "关班",
  cashier_dayopen: "开班",
  cashier_open_amount: "开启现金",
  cashin: {
    montax: {
      CHANGE: "备用金存入",
      CASHIER_DEPOSIT: "收银员取款",
      COLLECTION: "费用收取",
      LOTTERY_TICKET_SALE: "彩票销售",
      DEPOSIT: "预付款",
      DEFICIT: "收银机短缺",
      TIP: "小费",
      OTHER_CASH_IN: "其他存入"
    },
    a234: {
      "0": "备用金存入",
      "1": "收银员取款",
      "2": "费用收取",
      "3": "彩票销售",
      "4": "预付款",
      "5": "收银机短缺",
      "6": "小费",
      "7": "其他存入"
    },
    b1: {
      "1": "备用金存入",
      "2": "收银员取款",
      "3": "费用收取",
      "4": "彩票销售",
      "5": "预付款",
      "6": "收银机短缺",
      "7": "小费",
      "8": "其他存入"
    },
    fiscat: {
      "01": "备用金存入",
      "02": "收银员取款",
      "03": "费用收取",
      "04": "彩票销售",
      "05": "预付款",
      "06": "收银机短缺",
      "07": "小费",
      "08": "其他存入"
    },
    reason: "现金存入原因",
    sam4s: {
      "1": "备用金存入",
      "2": "收银员取款",
      "3": "费用收取",
      "4": "彩票销售",
      "5": "预付款",
      "6": "收银机短缺",
      "7": "小费",
      "8": "其他存入"
    },
    sam4s2: {
      "1": "备用金存入",
      "2": "收银员取款",
      "3": "费用收取",
      "4": "彩票销售",
      "5": "预付款",
      "6": "收银机短缺",
      "7": "小费",
      "8": "其他存入"
    },
    title: "现金存入"
  },
  cashout: {
    montax: {
      SKIMMING: "抽取现金",
      CASHIER_WITHDRAWAL: "收银员取款",
      VOUCHER_OUT: "凭证支出",
      GIFT_CARD_OUT: "礼品卡支出",
      SALARY_PAYMENT: "工资支出",
      ADVANCE_PAYMENT: "工资预支",
      POSTAL_FEE: "邮资费用",
      OTHER_FEES: "其他开支",
      PROCUREMENT: "商品采购",
      TURNOVER_WITHDRAWAL: "总支出",
      OTHER_CASH_OUT: "其他支出"
    },
    a234: {
      "0": "抽取现金",
      "1": "收银员取款",
      "10": "其他支出",
      "2": "凭证支出",
      "3": "礼品卡支出",
      "4": "工资支出",
      "5": "工资预支",
      "6": "邮资费用",
      "7": "其他开支",
      "8": "商品采购",
      "9": "总支出"
    },
    b1: {
      "31": "抽取现金",
      "32": "收银员取款",
      "41": "其他支出",
      "33": "凭证支出",
      "34": "礼品卡支出",
      "35": "工资支出",
      "36": "工资预支",
      "37": "邮资费用",
      "38": "其他开支",
      "39": "商品采购",
      "40": "总支出"
    },
    fiscat: {
      "31": "抽取现金",
      "32": "收银员取款",
      "33": "凭证支出",
      "34": "礼品卡支出",
      "35": "工资支出",
      "36": "工资预支",
      "37": "邮资费用",
      "38": "其他开支",
      "39": "商品采购",
      "40": "总支出",
      "41": "其他支出"
    },
    reason: "现金支出原因",
    sam4s: {
      "1": "抽取现金",
      "10": "关闭金额提取",
      "11": "其他支出",
      "2": "收银员取款",
      "3": "凭证提取",
      "4": "礼品卡提取",
      "5": "工资支付",
      "6": "工资预支",
      "7": "邮政费用",
      "8": "其他公用事业",
      "9": "商品采购"
    },
    sam4s2: {
      "1": "抽取现金",
      "10": "关闭金额提取",
      "11": "其他支出",
      "2": "收银员取款",
      "3": "凭证提取",
      "4": "礼品卡提取",
      "5": "工资支付",
      "6": "工资预支",
      "7": "邮政费用",
      "8": "其他公用事业",
      "9": "商品采购"
    },
    title: "现金支出"
  },
  cashRegister: "收银机",
  categories_or_menuitems: "菜单项或类别",
  category: "类别",
  celery: "芹菜",
  cash_return: "找零",
  change: "找零",
  change_table: "更换桌子",
  change_table_number: "更改桌号",
  changeit: "更改",
  channels: {
    console: "控制台",
    console_homedelivery: "",
    console_pickup: "",
    falatozz: "Falatozz",
    foodora: "Foodora",
    webshop_homedelivery: "网上商店",
    webshop_onsite: "网上商店",
    webshop_pickup: "网上商店",
    wolt: "Wolt"
  },
  charwidth: "字符宽度",
  checkbox_option: "下单时可以从类别中选择多个选项",
  checkbox_option2: "保持为单独选项类别，下单时可以从类别中选择多个选项",
  choose_customer_for: "为人员 {0} 选择顾客。",
  choose_parent_category: "选择父类别",
  choose_terminal_to_use: "选择使用的银行终端",
  city: "城市",
  clear: "清除",
  close: "关闭",
  close_order: "关闭订单",
  closed: "已关闭",
  collaborating_production_lines: "协作生产线",
  comment: "评论",
  comments: "备注",
  company: "餐厅/公司名称",
  company_name: "公司名称",
  confirm: {
    deleteResources: "您确定要删除以下资源吗：",
    deleteRole: "您确定要删除角色",
    undoAction: "此操作无法撤销。"
  },
  confirm_additional_table: "是否将桌号 {0} 添加到当前占用？",
  confirm_change_to_homedelivery: "更改为外卖配送？",
  confirm_change_to_pickup: "更改为自取？",
  confirm_change_to_table: "是否将所有人更换到桌号 {0}？",
  confirm_customer_deletion: "您确定要删除用户 <b>{0}</b> 吗？",
  confirm_not_printing: "您确定要跳过打印订单吗？",
  confirm_person_change_to_empty_table: "人员 {0} 是否更换到空桌 {1}？<br/>作为新占用还是继续当前占用？",
  confirm_person_change_to_multiple_occupation_table: "人员 {0} 是否加入到已占用桌 {1}？",
  confirm_person_change_to_shared_table: "人员 {0} 是否加入到已占用桌 {1}？<br/>作为新占用还是加入现有占用？",
  confirm_person_change_to_table: "人员 {0} 是否加入到已占用桌 {1}？",
  confirm_position_update: "刷新地址的GPS坐标",
  confirm_role_deletion: "您确定要撤销 <b>{1}</b> 对 <b>{2}</b> 的访问权限吗？",
  confirm_table_change_to_shared_table: "目标桌是共享桌，请选择可用选项。",
  confirm_table_change_to_table: "整个桌子是否加入到已占用桌 {0}？",
  confirmation_copy_all: "您想同步所有类别的产品吗？",
  connected_from: "已连接",
  connected_restaurant: "已连接餐厅",
  connected_restaurants: "已连接餐厅",
  connection: "连接",
  "Connection error with the cash register": "与收银机的连接错误",
  consumption: "销售量",
  container_charge: "容器费",
  container_charge_onsite: "本地消费时也收费",
  continue_in: "{0} 分钟后此警告将关闭，请等待...",
  continue_ordering: "继续点餐",
  continue_without_open_day: "继续无营业日",
  controlled_production_lines: "整体更改状态",
  cost: "成本",
  cost_estimation: "成本估算",
  could_not_find_this_order: "订单号 {0} 未找到!",
  could_not_find_this_order2: "订单未找到!",
  count: "数量",
  country: "国家",
  courier: "快递员",
  courier_delivering: "正在送货",
  courier_delivery_continue: "继续送货",
  courier_delivery_pause: "暂停送货",
  courier_off: "下班",
  courier_pause: "暂停",
  courier_ready: "等待送货",
  courierFee: "送货费",
  couriers: "快递员",
  created_by: "创建人",
  criticalStock: "危及业务运营的临界数量",
  cron: {
    andText: "和",
    atEveryText: "在/每",
    atOptionLabel: "在",
    betweenText: "之间",
    cronDescriptionText: "zh",
    dayOfMonthLabel: "日",
    dayOfWeekLabel: "星期几",
    everyOptionLabel: "每",
    everyText: "每",
    hourLabel: "小时",
    inText: "在",
    lastDayOfMonthLabel: "月的最后一天",
    minuteLabel: "分钟",
    monthLabel: "月",
    multiDayOfMonthLabel: "月的日期",
    onEveryText: "在/每",
    onOptionLabel: "在",
    onText: "在",
    periodLabel: "周期",
    periodOptions: ["小时", "天", "周", "月", "年"],
    shortMonthOptions: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"],
    weekDaysOptions: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"]
  },
  crustaceans: "甲壳类",
  cumulative: "累计",
  currencies: "货币",
  currency: "货币",
  custom_range: "自定义范围",
  custom_reason: "自定义原因",
  customer_table: {
    search: "搜索",
    name: "姓名",
    surname: "姓氏",
    email: "电子邮件",
    phone: "电话",
    address: "地址",
    city: "城市",
    postcode: "邮政编码",
    country: "国家",
    labels: "标签",
    delete: "删除",
    loading: "加载中...",
    no_results: "无结果",
    items_per_page: "每页",
    showing: "显示",
    of: "共",
    previous: "上一页",
    next: "下一页",
    import: "导入",
    import_preview: "导入预览",
    import_confirm: "立即导入",
    preview_rows: "预览 {0} 行",
    import_result: "已导入 {0}，已更新 {1}，已跳过 {2}",
    import_invalid: "仅支持 CSV、XLS 或 XLSX 文件。",
    original_excel: "原始 Excel",
    after_mapping: "映射后",
    primary: "主映射",
    fallback: "备用映射"
  },
  customer_details: "客户详细信息",
  customer_orders: "新客户订单",
  customerAddress: "客户地址",
  customerName: "客户姓名",
  customerOrder: "消费者订单（网上商店）",
  customerPostCode: "客户邮政编码",
  customerTaxNum: "客户税号",
  customerTown: "客户城市",
  customRange: "自定义范围",
  daily_closing: "每日结算",
  date: "日期",
  datetime: "日期和时间",
  day: "天",
  day_must_be_open: "首先开启营业日才能进行此操作！",
  day1: "星期日",
  day2: "星期一",
  day3: "星期二",
  day4: "星期三",
  day5: "星期四",
  day6: "星期五",
  day7: "星期六",
  days: ["星期一", "星期二", "星期三", "星期四", "星期五", "星期六", "星期日"],
  daysAgo: "{0}天前",
  deactivate: "禁用",
  default: "默认",
  default_cashregister_change: "<strong>{0}</strong> 应该是这台机器的默认收银机吗？",
  default_language: "默认",
  default_production_line: "默认生产线",
  default_store: "默认仓库",
  default_takeaway_vat_category: "外卖增值税",
  default_vat_category: "增值税",
  delete: "删除",
  delete_all_order_history: "删除所有订单历史记录",
  delete_order_history: "删除所有历史订单",
  delete_traffic: "删除流量",
  deleted: "已删除",
  deletion_not_allowed: "无法删除",
  deliverable_tables: "已准备好的餐点",
  delivered_refresh_position: "已交付并更新GPS",
  delivery: "送货",
  delivery_addresses: "地址数量",
  delivery_avg_time: "平均时间",
  delivery_count: "送货数量",
  delivery_distance: "距离（公里）",
  delivery_note_id: "送货单编号",
  description: "描述",
  detailed: "详细账单",
  differences_in_active: "激活状态差异",
  differences_in_additions: "配方选项差异",
  differences_in_available: "可订购性差异",
  differences_in_availableQuantities: "可用数量差异",
  differences_in_children: "子项差异",
  differences_in_description: "描述差异",
  differences_in_falatozz_availability: "Falatozz 可用性差异",
  differences_in_falatozz_price: "Falatozz 价格差异",
  differences_in_falatozzImage: "Falatozz图片差异",
  differences_in_foodora_availability: "Foodora 可用性差异",
  differences_in_foodora_price: "Foodora 价格差异",
  differences_in_foodoraImage: "Foodora图片差异",
  differences_in_foodpanda_availability: "Foodpanda 可用性差异",
  differences_in_foodpanda_price: "Foodpanda 价格差异",
  differences_in_image: "图片差异",
  differences_in_included_options: "配方差异（默认包含的配料）",
  differences_in_inventory: "库存项目设置差异",
  differences_in_kiosk: "自助点餐机状态差异",
  differences_in_labels: "标签差异",
  differences_in_mandatory_options: "配方差异（必选配料）",
  differences_in_manufacturer: "制造商差异",
  differences_in_name: "命名差异",
  differences_in_online: "网店状态差异",
  differences_in_optional_options: "可选选项差异",
  differences_in_pos: "POS 设置差异",
  differences_in_productionlines: "生产线差异",
  differences_in_quantitytype: "计量单位差异",
  differences_in_timing: "上菜时间差异",
  differences_in_top: "菜单状态差异",
  differences_in_unitPrice: "单价差异",
  differences_in_vat: "增值税差异",
  differences_in_wolt_availability: "Wolt 可用性差异",
  differences_in_wolt_price: "Wolt 价格差异",
  differences_in_woltImage: "Wolt图片差异",
  disable_edit_mode: "恢复餐桌布局",
  disconnected: "未连接",
  discount: "折扣",
  discount_amount: "固定金额",
  discount_percent: "百分比",
  discount_types: "折扣类型",
  discount_profit: "折扣利润",
  discounts: "折扣",
  disposed_quantity: "已处置数量",
  distance_to_big: "距离该位置设置的地址超过{0}公里！您现在真的是在此地址吗？如果是，我们是否根据您当前位置更新地址的GPS坐标？",
  do_you_really_delete_the_customer: "您真的想删除此客户吗？",
  do_you_really_want_to_delete_the_menu_category: "您确定要删除菜单类别吗？",
  do_you_really_want_to_delete_the_menu_item: "您确定要删除菜单项吗？",
  do_you_really_want_to_print_only_the_selected_orders: "您确定只打印选中的订单吗？",
  do_you_really_want_to_print_the_orders_until_timing: "您确定只打印到 <b>{0}</b> 这道菜的订单吗？",
  do_you_really_want_to_reprint_only_the_selected_orders: "您确定要 <b><u>重新打印</u></b> 选中的订单吗？",
  do_you_really_want_to_reprint_the_orders_until_timing: "您确定要 <b><u>重新打印</u></b> 订单直到 <b>{0}</b> 吗？",
  do_you_realy_want_to_order_so_many: "您确定要订购<strong>{0}</strong>件吗？",
  do_you_want_to_catch_incoming_calls: "您是否希望我们使用来电识别为此电话捕捉外卖/自取数据？如果是，请在浏览器中使用相同的用户登录！",
  documentation: "文档",
  bad: "错误",
  bad_entries: "错误条目",
  good_entries: "正确条目",
  barcode_filter_all: "全部",
  barcode_filter_central_status: "中央数据库状态",
  barcode_filter_entry_quality: "条目质量",
  barcode_filter_synced_with_central: "存在于全球数据库（本地 = 全局）",
  barcode_filter_different_from_central: "存在于全球数据库（本地 != 全局）",
  barcode_sync_choose_image_title: "选择要保留的图片",
  barcode_sync_choose_image_message: "本地和全局条目都包含图片。请选择要在两边都保留的图片。",
  barcode_sync_click_image_to_choose: "点击图片进行选择。",
  barcode_sync_hint_preferred: "提示：按评分优先",
  barcode_sync_keep_local_image: "保留本地图片",
  barcode_sync_keep_global_image: "保留全局图片",
  barcode_sync_local_image: "本地图片",
  barcode_sync_global_image: "全局图片",
  bad_barcode_entries: "错误条码条目",
  doesnt_exists_in_central_database: "不存在于全球数据库",
  dont_print: "不打印",
  door: "楼层/门",
  download: "下载",
  download_barcodes: "下载",
  download_template: "上传模板",
  draft: "草稿",
  drink: "饮品",
  drink_available_quantity: "可用数量",
  drink_category_editor: "饮料类别编辑器",
  drink_category_name: "类别",
  drink_editor: "饮料编辑器",
  drink_name: "名称",
  drink_price: "价格",
  drink_quantity: "数量",
  drink_quantity_name: "名称",
  drink_quantity_type: "数量类型",
  drinkbar: "饮料吧",
  drinks: "饮料",
  drop: "丢弃",
  duplicate: "复制",
  duration: "持续时间",
  edit: "编辑",
  eggs: "鸡蛋",
  email: "电子邮件",
  email_pattern: "[^@]+@[^@]+(\\.[^@]+)+",
  empty: "空",
  "Enable Report Scheduling": "启用报告调度",
  enable_edit_mode: "修改餐桌布局",
  "enabled-features": "启用的功能",
  end_count: "实际数量",
  enter_barion_pos_key: "请输入您的 Barion 秘密密钥（POSKey）",
  enter_category: "请输入类别名称",
  enter_cost: "设置成本",
  enter_description: "如有需要，请输入描述",
  enter_Drink_menuitem: "请输入饮品名称",
  enter_invoice_heading: "请输入发票的抬头（HTML 格式）！",
  enter_labels: "选择标签",
  enter_Meal_menuitem: "请输入餐点名称",
  enter_percent: "请输入增值税百分比（例如 27）",
  enter_phone_number: "输入电话号码",
  enter_price: "设置价格：例如 500 或 40%",
  new_price: "新价格",
  change_order_items_state: "更改订单项状态",
  edit_order: "编辑订单",
  enter_production_line_name: "请输入生产线名称",
  enter_table_number: "请输入桌号",
  enter_table_seats: "请输入可用座位数",
  enter_vat_category_name: "请输入增值税类别名称",
  entities: "实体们",
  entity: "实体",
  entity_type: "实体类型",
  entries: "条目",
  entry: "条目",
  entry_count: "记录数量",
  epd: "桌面显示",
  events: "事件",
  except: "除外",
  exchange_rate: "汇率",
  exists_in_central_database: "存在于全球数据库",
  exit_rearrange_mode: "退出重新排列模式",
  expiry_date: "有效期",
  extend_occupation: "延续当前占用",
  extensions: "扩展",
  "External HealthCheck: Successful": "打印机看起来正常",
  extra_frame_bottom: "下框内容",
  extra_frame_left: "左框内容",
  extra_frame_right: "右框内容",
  extra_frame_top: "上框内容",
  failed_to_create_production_line_not_unique: "创建生产线失败！名称不唯一！",
  failed_to_create_table_not_unique: "创建桌子失败。桌号已被使用！",
  failed_to_delete_discount_type_in_use: "删除折扣类型失败！它已经在使用中。请禁用它！",
  failed_to_delete_drink_category_in_use: "删除饮料类别失败！它已经在使用中。请禁用它！",
  failed_to_delete_drink_in_use: "删除饮料失败！它已经在使用中。请禁用它！",
  failed_to_delete_label_in_use: "删除标签失败！它已经在使用中！",
  failed_to_delete_meal_category_in_use: "删除餐品类别失败！它已经在使用中。请禁用它！",
  failed_to_delete_meal_in_use: "删除餐品失败！它已经在使用中。请禁用它！",
  failed_to_delete_production_line_in_use: "删除生产线失败！它已在使用中，请禁用它！",
  failed_to_delete_table_in_use: "该桌子无法删除！它已经被使用！请禁用它！",
  failed_to_delete_user: "删除失败。<br>错误: {0}",
  failed_to_delete_user_anonimize: "该用户无法删除！您想将其匿名化吗？姓名、邮箱和密码将被删除！",
  failed_to_execute_action: "操作失败！",
  failed_to_get_restaurant_layout: "未定义餐厅布局！请先上传布局！",
  failed_to_print_invoice: "打印发票失败！",
  failed_to_print_kitchen_slip: "打印厨房凭条失败！",
  failed_to_send_order: "发送订单失败：{0}",
  feedback: "反馈",
  feedbacks: "反馈",
  final_stock: "结束库存",
  finalCost: "结束成本",
  finalPrice: "结束价格",
  first_modify_start_date: "首先更改开始时间",
  fiscal_receipt_already_printed: "此财政收据已打印（收据号：{0}）",
  fiscat_service_fee: "服务费",
  fish: "鱼类",
  fix_quantity: "固定数量",
  floorplans: "楼层图",
  food: "食物",
  for_all: "适用于所有",
  for_selected_none: "适用于选定",
  for_selected_order: "适用于选定订单",
  for_selected_tableMate: "适用于选定人员",
  for_store: "适用于商店",
  format: "格式",
  free_seats: "空闲座位",
  from_store: "来源商店",
  fromDate: "开始日期",
  fromTime: "开始时间",
  full_inventory: "完整库存",
  partial_inventory: "部分盘点",
  generate_access_token: "生成访问令牌",
  getting_location: "正在确定您当前的位置...",
  global_id: "全球ID",
  global_value: "全球值",
  gluten: "麸质",
  Grid: {
    Pager: {
      Button: {
        backButtonText: "返回",
        nextButtonText: "下一步"
      },
      Description: {
        no_records: "没有可用的 %{recordType}",
        records_displayed: "%{firstIndex} 到 %{lastIndex} 共 %{total} %{recordType} 显示"
      }
    }
  },
  gross_weight: "毛重",
  hellopay: {
    error: {
      "1": "未知或其他错误",
      "10": "用户处于菜单中",
      "11": "外部标识符验证失败",
      "12": "交易加载失败",
      "13": "权限不足",
      "14": "终端状态不正确（由OTP/Unipass控制）",
      "2": "超时或中断，未找到卡片",
      "3": "无效或损坏的卡片",
      "4": "卡片余额不足",
      "5": "插入了错误的卡片",
      "6": "无法撤销，因为不是最后一次交易",
      "7": "不是HelloPay卡",
      "8": "卡片通信错误",
      "9": "平板通信错误"
    }
  },
  history: "历史",
  homedelivery: "家庭送货",
  hospitalityUnit: "酒店单位",
  hour: "小时",
  how_much: "金额",
  id: "标识符",
  if: "条件",
  image: "图片",
  included: "可移除",
  included_receipe: "产品中包含的成分，但可以在订购时去除或替换。例如，卡布奇诺中的牛奶可以用乳糖不耐症牛奶替换。",
  included_recipe: "产品中包含的成分，但可以在订购时去除或替换。例如，卡布奇诺中的牛奶可以用乳糖不耐症牛奶替换。",
  income: "收入",
  income_without_cost: "不包含成本的收入?",
  incoming_stock: "入库",
  incoming_stock_entry_text_input: "文本输入",
  incomingStock: "入库",
  incomingStocks: "入库记录",
  inDays: "{0}天后",
  inherit: "继承",
  initial_stock: "起始库存",
  initialCost: "起始成本",
  initialPrice: "起始价格",
  inMonths: "{0}个月后",
  input_stores: "输入仓库",
  install_printer_server: "安装打印服务器",
  installments_strategy: "付款计划",
  "Internal HealthCheck: Successful": "打印机看起来正常",
  inventory: "库存盘点",
  inventory_disposal: "库存处置",
  inventory_shortage: "库存短缺",
  inventory_surplus: "库存盈余",
  invoice: "发票",
  invoice_logo: "发票 logo",
  invoice_logo_padding: "发票 logo 调整",
  choose_image: "选择图片",
  use_restaurant_logo: "使用餐厅 logo",
  no_image_selected: "未选择图片",
  logo_padding_helper_hint: "棋盘背景可以显示添加的白色左右边距。",
  logo_width_ratio: "Logo 宽度比例",
  monochrome_threshold: "单色阈值",
  threshold_description: "低于此值的像素变为黑色；较亮的像素变为白色。",
  invoice_count: "原始数量",
  invoice_footer: "发票页脚",
  invoice_heading: "发票抬头",
  invoice_id: "发票编号",
  invoice_not_found: "在线发票系统中未找到发票号",
  invoice_printed: "发票成功发送至打印机",
  inYears: "{0}年后",
  is_paid: "已支付",
  isInventoryItem: "库存物品",
  isInventoryItem2: "库存物品/原材料",
  isInventoryItem3: "库存物品",
  isPos: "POS",
  isTop: "菜单上",
  item: "项目",
  joins: "加入",
  joins_table: "加入第 {0} 个占用，共 {1} 人",
  joins_table1: "加入第一个占用，共 {0} 人",
  kiosk: "自助点餐机",
  kioskOrder: "自助点餐机订单",
  label: "标签",
  label_count: "标签数量",
  label_printer: "标签打印机",
  labels: "标签",
  language: "语言",
  languages: "语言",
  last_3_months: "过去3个月",
  last_30_days: "过去30天",
  last_7_days: "过去7天",
  last_month: "上月",
  last_quarter: "上季度",
  last_status: "最后状态",
  last_week: "上周",
  lastBuy: "最后购买",
  lastInventory: "最后库存",
  lastSale: "最后使用",
  latitude: "纬度",
  layout_succesfully_saved: "餐桌布局已保存！",
  linked_product: "链接的自有产品",
  list: "列表",
  local_addition_tooltip: "适用于本地消费",
  local_consumption: "本地消费",
  local_product: "关联产品",
  local_url: "局域网URL",
  local_value: "本地值",
  localConsumption: "本地消费",
  lock: "占用",
  lock_homedelivery: "新送货上门",
  lock_pickup: "新取货",
  locked: "已锁定",
  longitude: "经度",
  lupin: "羽扇豆",
  make_bookOnline: "启用客人占用",
  make_kiosk: "成为自助点餐机",
  make_non_kiosk: "取消自助点餐机",
  make_non_pos: "不是销售点",
  make_nonBookOnline: "禁用客人占用",
  make_nonVisibleOnline: "隐藏桌子",
  make_pos: "设置为销售点",
  make_shareable: "使桌子可共享",
  make_unshareable: "使桌子不可共享",
  make_visibleOnline: "使桌子对客人可见",
  mandatory: "必选",
  mandatory_radio_option: "下单时必须选择一个选项",
  mandatory_receipe: "产品必须包含的成分。例如，披萨底部。",
  manual: "手动",
  manualOnly: "手动",
  manufacturer: "制造商",
  map: "地图",
  mate_already_joined_table_in_this_restaurant: "{0} 已经加入桌号 {1}！",
  maxPrice: "最大价格",
  maxStock: "最大库存",
  meal: "餐点",
  meal_available_quantity: "可用数量",
  meal_category_editor: "餐点类别编辑器",
  meal_category_name: "类别",
  meal_editor: "餐点编辑器",
  meal_name: "名称",
  meal_price: "价格",
  meal_quantity: "数量",
  meal_quantity_name: "名称",
  meal_quantity_type: "数量类型",
  meal_timing: "时间安排",
  meals: "餐点",
  menu: {
    show_category_image: {
      title: "显示产品类别图片"
    },
    show_menuitem_image: {
      title: "显示产品图片"
    },
    title: "点餐界面，产品选择器"
  },
  menuitem: "菜单项",
  menuitem_ordered: "订单项",
  menuitems: {
    _complex_product: "未售出复杂产品",
    _complex_product_ingredient: "未售出复杂产品子产品",
    _complex_product_ingredient_option: "未售出复杂产品子产品及选项",
    _complex_product_option: "未售出复杂产品及选项",
    _inventory: "未售出库存未使用原料",
    _inventory_ingredient: "未售出库存原料",
    _inventory_ingredient_option: "未售出库存原料及选项",
    _inventory_option: "未售出库存选项",
    _linked_product: "未售出引用产品",
    _linked_product_ingredient: "未售出引用产品子产品",
    _linked_product_ingredient_option: "未售出引用产品子产品及选项",
    _linked_product_option: "未售出引用产品及选项",
    _service: "未售出服务",
    _service_ingredient: "未售出服务子产品",
    _service_ingredient_option: "未售出服务子产品及选项",
    _service_option: "未售出服务选项",
    sold_complex_product: "售出复杂产品",
    sold_complex_product_ingredient: "售出复杂子产品",
    sold_complex_product_ingredient_option: "售出复杂子产品及选项",
    sold_complex_product_option: "售出复杂产品及选项",
    sold_inventory: "售出库存产品",
    sold_inventory_ingredient: "售出库存产品原料",
    sold_inventory_ingredient_option: "售出库存产品原料选项",
    sold_inventory_option: "售出库存产品选项",
    sold_linked_product: "售出链接产品",
    sold_linked_product_ingredient: "售出引用库存产品原料",
    sold_linked_product_ingredient_option: "售出引用库存产品原料选项",
    sold_service: "售出服务",
    sold_service_ingredient: "售出服务子产品",
    sold_service_ingredient_option: "售出服务子产品及选项",
    sold_service_option: "售出服务选项",
    tooltip: {
      _complex_product: "未直接售出的复杂产品，由其他产品组成",
      _complex_product_ingredient: "未直接售出的复杂产品，由其他产品组成，并在其他产品的配方中引用",
      _complex_product_ingredient_option: "未直接售出的复杂产品，由其他产品组成，并在其他产品的配方中引用，并作为选项",
      _complex_product_option: "未直接售出的复杂产品，由其他产品组成，并作为另一个产品的选项",
      _inventory: "未直接售出的库存原料，未被其他产品使用/引用",
      _inventory_ingredient: "未直接售出的库存原料，已在另一产品的配方中引用",
      _inventory_ingredient_option: "未直接售出的库存原料，已在另一产品的配方中引用，并作为选项",
      _inventory_option: "未直接售出的库存原料，已在另一产品中作为选项引用",
      _linked_product: "未直接售出的引用产品（价格不同、特殊数量或仅是另一产品的副本）",
      _linked_product_ingredient: "未直接售出的引用产品（价格不同、特殊数量或仅是另一产品的副本），并包含在另一产品的配方中",
      _linked_product_ingredient_option: "未直接售出的引用产品（价格不同、特殊数量或仅是另一产品的副本），并在另一产品的配方中引用，并作为选项",
      _linked_product_option: "未直接售出的引用产品（价格不同、特殊数量或仅是另一产品的副本），并作为另一个产品的选项",
      _service: "未售出的服务，未被其他产品引用为配方或选项",
      _service_ingredient: "未直接售出的服务，已在另一产品的配方中引用",
      _service_ingredient_option: "未直接售出的服务，已在另一产品的配方中引用，并作为选项",
      _service_option: "未直接售出的服务，已在另一产品中作为选项引用",
      active: "激活的产品",
      available_online: "产品可在线订购",
      deactivated: "已停用的产品",
      def_is_inventory_item: "默认但不能选择作为包装选项。此设置不佳。请选择默认可销售包装！此单元是库存管理的基础。可以以此单元接收并库存。",
      def_non_inventory_item: "默认但不能选择作为包装选项。此设置不佳。请选择默认可销售包装！普通产品数量。不是库存单元。",
      def_on_menu_is_inventory_item: "默认并可以在销售过程中选择作为包装选项。此单元是库存管理的基础。可以以此单元接收并库存。",
      def_on_menu_non_inventory_item: "默认并可以在销售过程中选择作为包装选项。普通产品数量。不是库存单元。",
      default_inventory_item: "库存管理的产品（原材料）。从其类别继承此属性。",
      default_not_inventory_item: "非库存管理的产品。从其类别继承此属性。",
      expected_profit: "预期利润率",
      free_quantity: "在订购时，售出的数量可以自由修改（例如，称重商品时需要）。",
      inventory_item: "库存管理的产品（原材料）",
      is_inventory_item: "在销售过程中不能选择作为包装选项。此单元是库存管理的基础。可以以此单元接收并库存。",
      no_inventory_quantity_selected: "产品是库存单元，但未选择库存数量。",
      non_inventory_item: "在销售过程中不能选择作为包装选项。普通产品数量。不是库存单元。",
      not_available_online: "产品当前不可在线订购",
      not_free_quantity: "在订购时只能选择预定义的包装选项（数量）。",
      not_inventory_item: "非库存管理的产品（原材料）",
      not_on_kiosk: "不可在自助终端上使用",
      not_on_menu: "非主产品，不能直接下单，仅作为其他产品的选项",
      not_online: "产品在在线商店不可见",
      not_pos: "不可由服务员或销售人员在现场点单",
      on_kiosk: "可在自助终端上使用",
      on_menu: "主产品，可直接下单",
      on_menu_is_inventory_item: "可以在销售过程中选择作为包装选项。此单元是库存管理的基础。可以以此单元接收并库存。",
      on_menu_non_inventory_item: "可以在销售过程中选择作为包装选项。普通产品数量。不是库存单元。",
      online: "产品在在线商店可见",
      pos: "可由服务员或销售人员在现场点单",
      profit_ratio: "利润率",
      sold_complex_product: "售出复杂产品，由其他产品组成",
      sold_complex_product_ingredient: "售出复杂子产品，由其他产品组成",
      sold_complex_product_option: "售出复杂产品，由其他产品组成，并作为另一个产品的选项",
      sold_inventory: "售出库存管理的成品，即售出的产品也是已库存的原材料。",
      sold_inventory_ingredient: "售出库存管理的成品，即售出的产品也是已库存的原材料，且为另一产品的原料。",
      sold_inventory_ingredient_option: "售出库存管理的成品，即售出的产品也是已库存的原材料，且为另一产品的原料，并作为选项。",
      sold_inventory_option: "售出库存管理的成品，即售出的产品也是已库存的原材料，且为另一产品的选项。",
      sold_linked_product: "售出链接产品",
      sold_linked_product_ingredient: "售出链接产品原料",
      sold_linked_product_ingredient_option: "售出引用产品，子产品，选项，即它仅引用一个产品",
      sold_linked_product_option: "售出引用产品，选项，即它仅引用一个产品",
      sold_service: "售出服务，产品未库存（非原材料），且不包含其他产品（空配方），因此为服务。",
      sold_service_ingredient: "售出服务子产品，产品未库存（非原材料），且不包含其他产品（空配方），因此为服务，但在其他产品的配方中有所引用。",
      sold_service_ingredient_option: "售出服务原料选项，即产品本身未库存（非原料），且不包含其他产品（空配方），因此为服务，且其他产品的配方中引用了它作为选项。",
      sold_service_option: "售出服务选项，即产品本身未库存（非原料），且不包含其他产品（空配方），因此为服务，且其他产品引用它作为选项。",
      suggested_price: "建议价格",
      to_many_inventory_quantity_selected: "产品有多个库存数量，因此系统无法确定应从哪个数量中减少库存。请仅选择一个库存数量。",
      unit_cost: "净购进价",
      unit_price: "本地消费单价"
    }
  },
  menus: {
    administration: "管理",
    advertisements: "广告",
    analytics: "分析",
    bankTerminal: "银行终端",
    bankTerminals: "银行终端",
    bar: "酒吧",
    barcodes: "条形码",
    bi: "商业智能",
    cashRegisters: "收银机",
    check_subscriptions: "检查订阅",
    comments: "评论",
    customers: "客户",
    currencies: "货币",
    daily_closing: "日结",
    discounts: "折扣",
    drinks: "饮品",
    falatozz: "Falatozz",
    falatozz_administration: "Falatozz 管理",
    foodora_administration: "Foodora 管理",
    foodpanda: "FoodPanda",
    guestScreen: "客人屏幕",
    incomingStocks: "进货",
    inventory: "库存",
    inventoryScrapping: "库存报废",
    kiosks: "自助点餐机",
    labels: "标签",
    pricetags: "价格标签",
    manage_reports: "管理报告",
    mautic: "CRM",
    meals: "餐点",
    menuitems: "菜单项",
    monitoring: "监控",
    opening_hours: "营业时间",
    orders: "订单",
    orders_quick_action: "设置订单状态",
    paymentMethods: "支付方式",
    plans: "计划",
    pointOfSales: "销售点",
    printers: "打印机",
    productionLines: "生产线",
    products: "产品",
    profile: "我的个人资料",
    rbac: "访问角色",
    reports: "报告",
    restaurants: "餐厅",
    scales: "秤",
    send_reseller_fees: "发送分销商费用",
    send_reseller_fees_to_me: "只发送分销商费用给我",
    serving: "服务",
    servings: "份数",
    shoppingList: "购物清单",
    stockList: "库存管理",
    stockManagement: "库存管理",
    stockMovements: "库存流动",
    stockReport: "库存报告",
    stores: "商店",
    superAdminMenu: "超级管理员",
    suppliers: "供应商",
    support: "支持",
    tableBooking: "桌面预订",
    tableOverview: "桌面概览",
    tables: "桌子",
    todaytraffic: "今日流量",
    traffic: "流量",
    updateSettings: "更新设置",
    users: "用户",
    VATCategories: "增值税类别",
    voipphone: "VOIP 电话",
    waiterScreen: "服务员屏幕",
    wolt: "Wolt",
    wolt_administration: "Wolt 管理",
    guidelines_whats_new: "指南与新功能",
    video_guides: "视频指南",
    chat_with_support: "与支持聊天"
  },
  milk: "牛奶",
  minimum_price: "最终价格不能低于基础价格，即使在下单时关闭默认选项。例如，披萨即使去掉了某些配料，价格也不能变便宜。",
  minimumStock: "通常进行补货时的最小数量",
  minPrice: "最小价格",
  minStock: "最小库存",
  minute: "分钟",
  minutes: "分钟",
  modified_by: "修改人",
  mollusks: "软体动物",
  month: "月",
  monthsAgo: "{0}个月前",
  more_addresses: "其他地址",
  more_than_a_day: "> 1 天",
  kitchen_total_time: "总计",
  move_back: "移动到底部",
  move_backward: "向后移动",
  move_forward: "向前移动",
  move_top: "移动到顶部",
  moved_quantity: "转移数量",
  multiple_inventory_quantity_selected: "您确定要设置多个单独的库存数量吗！",
  multiple_physical_printers_try_to_server_the_virtual_server: "为虚拟打印机 {0} 配置了多个物理打印机！ '{1}' 和 '{2}'！",
  multiplicator: "倍数",
  mustard: "芥末",
  myOrders: "我的订单",
  mode: "模式",
  templates: "模板",
  select: "选择",
  save_as_template: "保存为模板",
  template_name: "模板名称",
  template_name_required: "模板名称为必填项。",
  fill_out_guide: "填写说明",
  inventory_excel_menu_item_id: "产品ID",
  inventory_excel_menu_item_global_id: "产品全局ID",
  inventory_excel_inventory_quantity: "盘点数量单位值",
  inventory_excel_count: "盘点数量",
  inventory_excel_guide_no_unit: "如果未写单位，系统会按“数量 × 数量单位 × 数量类型”来解释。例如：数量=1000，单位=g，值=2 => 2 × 1000g = 2000g。",
  inventory_excel_guide_editable_column: "只有\"{0}\"列可编辑。",
  inventory_excel_guide_units: "可以输入如 10l、10dl、10g、10kg、10pcs，系统会自动换算。",
  invalid_inventory_count: "请使用数字，或使用与该商品匹配的单位格式。",
  inventory_excel_guide_interpretation: "盘点数量会按该行盘点单位解释：{0} + {1}。",
  inventory_excel_guide_empty_skipped: "如果盘点数量为空，导入时将跳过该行。",
  no_traffic_items_message: "以下商品近期没有活动，因此将从此库存中排除：{0}{1}",
  exclude_no_traffic_items: "排除商品",
  keep_no_traffic_items: "保留商品",
  no_entries_can_be_added_for_selected_store: "无法为所选门店添加条目。",
  search: "搜索",
  guidelines_whats_new_intro: "基于角色的更新与操作指南。",
  video_guides_intro: "展示最常见操作的简短视频。",
  video_guides_search_placeholder: "搜索标题、摘要或标签",
  video_guides_empty: "没有符合搜索条件的视频指南。",
  video_guides_coming_soon: "视频即将上线",
  video_guides_play: "播放视频",
  video_guides_large_player: "大播放器（高清）",
  video_guides_open_youtube: "在 YouTube 上打开",
  video_guides_close: "关闭",
  video_guides_recorded_with: "Playwright 脚本",
  video_guides_show_script: "显示脚本",
  video_guides_hide_script: "隐藏脚本",
  video_guides_script_missing: "脚本尚未导出。请运行：npm run video:export",
  voice_order_open: "语音点单",
  voice_order_title: "语音点单",
  voice_order_close: "关闭",
  voice_order_start: "打开麦克风",
  voice_order_stop: "关闭麦克风",
  voice_order_connecting: "连接中...",
  voice_order_stopped: "麦克风已关闭",
  voice_order_listening: "正在聆听，请说出客人想要的",
  voice_order_thinking: "思考中...",
  voice_order_speaking: "正在说话...",
  voice_order_empty: "列表为空。",
  voice_order_comment: "备注",
  voice_order_remove: "删除",
  voice_order_clear: "清空",
  voice_order_add: "添加到桌台订单",
  voice_order_not_configured: "服务器尚未设置语音点单。",
  voice_order_session_failed: "无法启动语音助手，请稍后重试。",
  voice_order_mic: "无法使用麦克风。请允许应用使用麦克风。",
  voice_order_connection: "语音连接已中断。",
  voice_order_no_table: "请先选择桌台，然后将列表添加到该桌台的订单。",
  voice_order_incomplete: "部分商品未能下单，其余仍保留在列表中。",
  voice_action_confirm: "确认",
  voice_order_lock_failed: "无法打开该桌。请先在屏幕上打开。",
  voice_order_print_failed: "已添加商品，但未能提交并打印。请使用“下单并打印”。",
  voice_action_dismiss: "取消",
  voice_action_done: "已完成",
  voice_action_failed: "操作失败",
  voice_move_confirm: "将 %{from} 换到 %{to}？",
  voice_join_confirm: "将 %{from} 换到 %{to} 并与那里的客人合并？",
  voice_new_confirm: "将 %{from} 作为单独的一桌安排到共享桌 %{to}？",
  voice_extend_confirm: "将共享桌 %{to} 并入 %{from}？",
  voice_add_table_confirm: "将 %{to} 添加到 %{from}？",
  voice_remove_orders_confirm: "删除订单：%{items}？",
  voice_unlock_confirm: "关闭 %{table}？",
  voice_unlock_confirm_cancel: "关闭 %{table} 并取消 %{count} 个未付款订单？",
  guidelines_whats_new_search_label: "搜索",
  guidelines_whats_new_search_placeholder: "搜索标题、摘要、详情或标签",
  guidelines_whats_new_filter_type_all: "全部类型",
  guidelines_whats_new_filter_freshness_all: "全部更新",
  guidelines_whats_new_date_range_label: "日期范围",
  guidelines_whats_new_filter_module_all: "全部标签",
  guidelines_whats_new_filter_module_placeholder: "请选择标签",
  guidelines_whats_new_date_range_all_time: "全部时间",
  guidelines_whats_new_date_range_1day: "修改于过去 1 天内",
  guidelines_whats_new_date_range_1week: "修改于过去 1 周内",
  guidelines_whats_new_date_range_1month: "修改于过去 1 个月内",
  guidelines_whats_new_date_range_2months: "修改于过去 2 个月内",
  guidelines_whats_new_date_range_3months: "修改于过去 3 个月内",
  guidelines_whats_new_date_range_1year: "修改于过去 1 年内",
  guidelines_whats_new_structure_title: "按标签分组",
  guidelines_whats_new_journey_orders: "点单与服务",
  guidelines_whats_new_journey_kitchen_delivery: "后厨与配送",
  guidelines_whats_new_journey_inventory_admin: "库存与管理",
  guidelines_whats_new_journey_administration: "管理",
  guidelines_whats_new_journey_insights: "报表与洞察",
  guidelines_whats_new_module_sales: "销售",
  guidelines_whats_new_module_kitchen: "后厨",
  guidelines_whats_new_module_stockmanagement: "库存管理",
  guidelines_whats_new_module_reports: "报表",
  guidelines_whats_new_module_administration: "管理",
  guidelines_whats_new_module_integrations: "集成",
  guidelines_whats_new_type_guideline: "已修改",
  guidelines_whats_new_type_whats_new: "新增",
  guidelines_whats_new_freshness_new: "新增",
  guidelines_whats_new_freshness_changed: "已修改",
  guidelines_whats_new_freshness_stable: "稳定",
  guidelines_whats_new_created_at: "创建时间",
  guidelines_whats_new_modified_at: "修改时间",
  guidelines_whats_new_reset_filters: "重置",
  guidelines_whats_new_results: "结果",
  guidelines_whats_new_empty: "当前角色暂无可用更新。",
  name: "名称",
  not_logged_in_yet: "尚未登录",
  superadmin: {
    add_user: "添加用户",
    edit_user: "编辑用户",
    activate_user: "激活用户",
    deactivate_user: "停用用户",
    add_role: "添加角色",
    delete: "删除",
    sync_to_mautic: "同步到Mautic",
    user: "用户",
    online: "在线",
    active: "活跃",
    role: "角色",
    entity_type: "实体类型",
    entity: "实体",
    filter_by_name: "按姓名过滤...",
    filter_by_entity: "按实体过滤...",
    all: "全部",
    offline: "离线",
    deactivated: "已停用",
    default: "默认",
    admin: "管理员",
    printer_server: "打印服务器",
    user_replication: "用户复制",
    tester: "测试员",
    waiter: "服务员",
    finance: "财务",
    inventory: "库存",
    courier: "快递员",
    restaurant: "餐厅",
    store: "商店",
    none: "无",
    loading: "加载中...",
    no_users_found: "未找到用户",
    yes: "是",
    no: "否",
    show: "显示",
    entries: "条目",
    showing: "显示",
    to: "到",
    of: "共",
    previous: "上一页",
    next: "下一页",
    user_editor: "用户编辑器",
    add_user_title: "添加用户",
    edit_user_title: "编辑用户",
    name: "姓名",
    surname: "姓氏",
    email: "电子邮件",
    password: "密码",
    gitlab_secure_token: "GitLab安全令牌",
    close: "关闭",
    save: "保存",
    role_editor: "角色编辑器",
    users: "用户",
    entities: "实体",
    confirmation: "确认",
    delete_user_confirm: "您确定要删除用户{0}吗？"
  },
  name_of_customer: "设置顾客姓名",
  net_price: "净价格",
  net_unit_price: "净单价",
  netto_income: "净收入",
  new: "新",
  new_in_central_database: "来自全球数据库",
  new_independent_occupation: "新占用",
  new_lock: "+ 占用",
  new_occupation: "作为新占用",
  new_order: "新订单",
  new_position: "此地址未设置GPS坐标。您想将其设置为您当前位置吗？",
  new_sale: "新销售",
  next: "下一步",
  nextInventory: "下次计划库存",
  no: "否",
  "No connection with the guest display": "与客户显示器无连接",
  "No tip": "无小费",
  no_bluetooth_adapter: "蓝牙接口不可用！",
  no_bluetooth_cashiers: "请连接或配对一个蓝牙收银机！",
  no_inventory_quantity: "未选择库存数量进行处理！",
  no_inventory_quantity_selected: "库存项但未选择库存数量！",
  no_matches_found: "没有找到匹配项",
  no_permission_to_perform_this_action: "您没有执行此操作的权限。",
  no_restaurants_found: "未找到餐厅",
  no_serial_cashiers: "请连接一个带有 USB-串口的收银机！",
  non_printer_configured: "未配置打印机",
  not_allowed_order_is_being_paid: "正在支付的订单不允许进行此操作！",
  not_allowed_order_paid: "支付订单时不允许进行此操作！",
  not_defined: "???",
  not_empty_pattern: "\\w+",
  not_selected: "未选择",
  not_used_ingredient: "未使用的原料",
  ntak: {
    _default_ntak_main_category: "主分类",
    _default_ntak_sub_category: "子分类",
    categories: "NTAK",
    cert: "证书（CER）",
    cert_request: "证书请求（CSR）",
    cert_request_download: "下载证书请求",
    cert_request_generate: "生成新的证书请求",
    cert_upload: "上传证书",
    default_ntak_main_category: "NTAK 主分类",
    default_ntak_sub_category: "NTAK 子分类",
    key: "私钥（KEY）",
    key_upload: "上传私钥",
    main_categories: [{ "id": 5, "name": "食品", "shortName": "食品", "sub_categories": [{ "id": 1, "name": "早餐" }, { "id": 2, "name": "三明治" }, { "id": 3, "name": "开胃菜" }, { "id": 4, "name": "汤" }, { "id": 5, "name": "主菜" }, { "id": 6, "name": "配菜" }, { "id": 7, "name": "泡菜/沙拉", "shortName": "泡菜/沙拉" }, { "id": 8, "name": "甜点" }, { "id": 9, "name": "小吃" }, { "id": 30, "name": "主菜配配菜" }, { "id": 31, "name": "食品套餐" }, { "id": 10, "name": "其他" }] }, { "id": 1, "name": "本地制作的非酒精饮料", "shortName": "本地饮料", "sub_categories": [{ "id": 11, "name": "柠檬水/糖浆/现榨饮料", "shortName": "柠檬水/糖浆/现榨" }, { "id": 12, "name": "非酒精鸡尾酒", "shortName": "非酒精鸡尾酒" }, { "id": 13, "name": "茶/热巧克力" }, { "id": 14, "name": "咖啡" }, { "id": 32, "name": "饮料套餐" }] }, { "id": 2, "name": "非本地制作的非酒精饮料", "shortName": "非本地饮料", "sub_categories": [{ "id": 15, "name": "水" }, { "id": 16, "name": "碳酸软饮" }, { "id": 17, "name": "非碳酸软饮" }, { "id": 33, "name": "非碳酸软饮" }, { "id": 32, "name": "饮料套餐" }] }, { "id": 3, "name": "酒精饮料", "shortName": "酒精饮料", "sub_categories": [{ "id": 18, "name": "鸡尾酒" }, { "id": 19, "name": "利口酒" }, { "id": 20, "name": "烈酒" }, { "id": 21, "name": "啤酒" }, { "id": 22, "name": "葡萄酒" }, { "id": 23, "name": "香槟" }, { "id": 32, "name": "饮料套餐" }] }, { "id": 4, "name": "其他", "shortName": "其他", "sub_categories": [{ "id": 10, "name": "其他" }, { "id": 26, "name": "送货费" }, { "id": 27, "name": "环保包装", "shortName": "环保包装" }, { "id": 28, "name": "塑料包装", "shortName": "塑料包装" }, { "id": 29, "name": "折扣" }, { "id": 34, "name": "非餐饮" }] }],
    mainCategoryNotSet: "没有为任何产品设置 NTAK 主分类！它可以在类别级别设置（将继承），也可以在产品级别设置。",
    ntak: "NTAK",
    ntak_id: "NTAK ID",
    save_ntak_id: "保存 NTAK ID",
    status: "NTAK 状态",
    status_error: "NTAK 错误",
    subCategoryNotSet: "没有为任何产品设置 NTAK 子分类！它可以在类别级别设置（将继承），也可以在产品级别设置。",
    taxid: "税号",
    test: "测试连接"
  },
  number_of_persons: "人数",
  number_of_seats: "可用座位",
  nuts: "坚果",
  occupy: "占用",
  ok: "确定",
  oldest_order: "最新订单: {0}",
  on_day: "星期几",
  online: "在线",
  online_szamla_feature: "您的订阅中当前未激活在线发票模块。该模块可以下载在在线发票系统中收到的增值税发票，并根据需要自动/半自动记录。",
  onsite: "现场消费",
  open: "打开",
  open_day: "营业日",
  opened: "打开",
  opening_time: "开门时间",
  option: "选项",
  optional: "选项",
  optional_radio_option: "下单时最多选择一个选项",
  optional_receipe: "在订购时可以增强产品或替代默认成分的额外选项。",
  optional_recipe: "在订购时可以增强产品或替代默认成分的额外选项。",
  order_cannot_be_deleted_while_mate_is_paying: "正在支付的人的订单无法删除！<br/>请先取消该人的支付状态！",
  order_cannot_be_deleted_while_order_was_already_selected_for_payment_one: "已选择支付的订单只能由管理员删除！",
  order_fee: "系统使用费",
  order_no: "订单号",
  order_number: "订单号: {0}",
  order_sequence_number: "订单号",
  order_summary: "订单摘要",
  ordered_by: "点餐人",
  ordering_allowed: "账单已撤销，允许再次下单！",
  orders: "订单",
  orders_tab: "订单列表",
  organizer: "组织者: {0}",
  original_quantity: "原始数量",
  other: "其他",
  outgoing_stock: "库存流动",
  output_stores: "输出仓库",
  package: "包裹",
  package_charge: "包装费",
  paid: "已支付",
  paid_by: "支付人",
  paid_order_cannot_be_deleted: "已支付的订单无法删除！",
  parent_category: "父类别",
  pay: "支付",
  pay_himself: "自付",
  payer: "付款人",
  paying: "支付中",
  payment: "支付",
  payment_due_in: "{0} 天内到期的付款!",
  payment_method: "支付方式",
  payment_methods: "支付方式",
  payment_received_by: "付款接收者",
  payment_successful: "支付成功",
  payment_was_due_in: "{0} 天前付款到期!",
  payments: "支付",
  paynance: {
    error: {
      "Transaction aborted": "交易已中止",
      "Transaction canceled by user": "用户手动取消交易",
      "Transaction timed out": "交易因超时而取消"
    }
  },
  pays: "支付",
  peanuts: "花生",
  pending: "待处理",
  per_item: "按项",
  percent_name: "百分比",
  person: "人员",
  person_count: "人数",
  persons: "人数",
  phone_order_fee: "电话订单系统使用费",
  phonenumber: "电话号码",
  pickup: "自取",
  pickupyourorder: "您的订单已准备好",
  picture: "图片",
  planned_closing_time: "计划关闭时间",
  "Please pick a tip to proceed to payment!": "请选择小费以继续支付！",
  please_choose_mate_wanting_to_pay: "谁想支付？",
  please_choose_mate_who_paid: "谁已支付？",
  please_click_on_a_time_slot_first: "请先选择预订开始时间（点击时间段）！",
  please_select_a_restaurant: "请选择餐厅",
  point_of_sale: "POS",
  pointin: "积分兑换",
  pointout: "积分累积",
  pos_producing_rules: "销售点打印后的状态",
  postcode: "邮政编码",
  postcode_pattern: "^\\d\\d\\d\\d$",
  preorder_possible: "预订",
  price: "价格",
  price_estimation: "建议价格",
  price_goal: "目标价格",
  pricePerCostRatio: "单价 / 成本比",
  print: "打印",
  print_invoice: "打印发票",
  print_qrcode: "打印二维码",
  print_receipt: "打印收据",
  printer: "打印机",
  printer_actions: "打印操作",
  printer_errors: {
    "cover-open": "封面打开",
    error: "连接错误",
    "out-of-paper": "纸用完了"
  },
  printer_server: "打印机服务器",
  printer_server_name: "打印服务器名称",
  network_speeds: "网络速度",
  client: "客户端",
  client_server: "客户端/服务器",
  sse: "SSE",
  download: "下载",
  upload: "上传",
  ip_address: "IP",
  printers: "打印机",
  printInvoice: "打印发票",
  printTableSlip: "打印桌号二维码",
  printVATInvoice: "打印增值税发票",
  privacy_policy: "隐私政策",
  privacy_policy_link: "https://eatwithme.online/privacy-policy/",
  producing_rules: "打印后的状态",
  product: "产品",
  product_modified_save_it: "已修改的产品！",
  product_receipe_modified_recalculate_it: "配方已更改。您是否想重新计算过去的库存",
  product_search: "产品搜索",
  product_serving: "类型",
  productAnalitics: "产品分析",
  production_line: "生产线",
  production_line_editor: "生产线编辑",
  production_line_is_active: "生产线已激活",
  production_line_length: "队列",
  production_line_name: "名称",
  production_line_title: "{0} 生产线",
  production_line_waiting: "依赖生产线",
  production_lines: "生产线",
  profit_margin: "利润率",
  profitandloss: {
    avgActualPrice: "平均价格",
    avgCost: "平均成本",
    avgDiscount: "平均折扣",
    avgPrice: "平均列表价格",
    closing_stock: "结算库存",
    consumption: "销售数量",
    cost: "成本",
    count: "销售数量",
    income: "收入",
    maxCost: "最高成本",
    maxPrice: "最高价格",
    minCost: "最低成本",
    minPrice: "最低价格",
    open_stock: "开盘库存",
    profit: "利润",
    profitp: "利润 (%)",
    purchase: "购买",
    scrapping: "报废",
    shortage: "短缺/过剩",
    stock_change: "库存变动"
  },
  proportional_addition_tooltip: "按比例增加。实际增加量将是基础项目的选定数量与附加项的数量的乘积。",
  provide_address: "请输入您的地址",
  provide_city: "请输入您的城市",
  provide_company: "请输入您的餐厅和/或公司名称",
  provide_country: "请输入您的国家",
  provide_phonenumber: "请输入您的电话号码",
  purchase_price: "净购买价格",
  qr_code: "二维码",
  quantity: "数量",
  quantity_must_be_unique: "可用数量必须唯一！",
  quantity_type: "数量类型",
  quantity_types: "服务类型",
  rateus: "请发送您的反馈！",
  rbac: "访问角色",
  ready_for_delivery: "准备送餐",
  rearrange_fields: "重新排列字段",
  reauthenticate: "重新认证",
  reboot_printerserver: "重新启动本地打印机服务器",
  recalculateConsumption: "重新计算库存",
  recalculateConsumptionAll: "重新计算所有库存",
  receipe: "食谱",
  receipt: "收据",
  receiptNumber: "收据号",
  receipts: "收据",
  references: "参考",
  refillStock: "通常补货时的目标数量",
  refresh: "刷新",
  refresh_my_data: "更新我的数据",
  refresh_position: "刷新",
  rejection_reason: "拒绝原因",
  reload_console: "重新加载控制台",
  refresh_kiosks: "刷新自助点餐机",
  repay_invoice_dialog: "您是否希望修改支付详情?",
  replace: "替换",
  reprint: "重新打印",
  reprint_receipt: "您真的想重新打印收据吗？",
  resend: "重试",
  reset_to_defaults: "重置为默认值",
  resource: {
    administration: {
      advertisements: {
        description: "广告管理",
        name: "广告"
      },
      bankterminals: {
        description: "银行卡终端管理",
        name: "银行卡终端"
      },
      cashregisters: {
        description: "收银机管理",
        name: "收银机"
      },
      description: "系统管理",
      discounts: {
        description: "折扣管理",
        name: "折扣"
      },
      falatozz: {
        description: "Falatozz集成",
        name: "Falatozz"
      },
      foodpanda: {
        description: "Foodpanda集成",
        name: "Foodpanda"
      },
      labels: {
        description: "标签管理",
        name: "标签"
      },
      name: "管理",
      printers: {
        description: "打印机管理",
        name: "打印机"
      },
      productionlines: {
        description: "生产线管理",
        name: "生产线"
      },
      products: {
        description: "产品管理",
        fullaccess: {
          description: "产品管理完全访问权限",
          name: "完全访问权限"
        },
        limitedaccess: {
          description: "有限的产品访问权限",
          name: "有限访问权限"
        },
        name: "产品"
      },
      rbac: {
        description: "基于角色的访问控制",
        name: "访问角色"
      },
      restaurants: {
        description: "餐厅设置",
        name: "餐厅"
      },
      scales: {
        description: "秤管理",
        name: "秤"
      },
      servings: {
        description: "服务管理",
        name: "服务"
      },
      tables: {
        description: "桌子管理",
        name: "桌子"
      },
      vatcategories: {
        description: "增值税类别管理",
        name: "增值税类别"
      },
      wolt: {
        description: "Wolt集成",
        name: "Wolt"
      }
    },
    bar: {
      description: "酒吧管理",
      name: "酒吧"
    },
    courierapp: {
      description: "快递员应用程序访问",
      name: "快递员应用程序",
      registerpayment: {
        description: "在快递员应用程序中注册支付",
        name: "支付注册"
      },
      selfassign: {
        description: "快递员自动分配订单",
        name: "自动分配"
      },
      view: {
        name: "打开"
      }
    },
    guestscreen: {
      description: "客人显示器管理",
      name: "客人显示器"
    },
    kiosk: {
      description: "自助点餐机系统",
      name: "自助点餐机"
    },
    kitchen: {
      description: "厨房显示系统 (KDS)",
      name: "KDS"
    },
    newsletter: {
      description: "通讯管理",
      name: "通讯"
    },
    ntak: {
      description: "NTAK系统",
      name: "NTAK"
    },
    reports: {
      bi: {
        customers: {
          description: "客户分析",
          name: "客户分析"
        },
        delivery: {
          description: "配送分析",
          name: "配送分析"
        },
        description: "商业智能报告",
        financial: {
          description: "收入分析",
          name: "收入"
        },
        financial_day: {
          description: "日收入分析",
          name: "日收入"
        },
        name: "商业智能报告",
        profit: {
          description: "利润分析",
          name: "利润分析"
        },
        rating: {
          description: "评分分析",
          name: "评分分析"
        }
      },
      dailyclosing: {
        description: "日结报告",
        name: "日结"
      },
      description: "报告和分析",
      menuitems: {
        description: "产品报告",
        name: "产品"
      },
      name: "报告",
      prebookedorders: {
        description: "预订订单报告",
        name: "预订订单"
      },
      tableoccupations: {
        description: "桌面占用和订单",
        name: "订单",
        revert: {
          description: "重新开放/取消已关闭的订单",
          name: "重新开放"
        },
        view: {
          name: "打开"
        }
      },
      todaytraffic: {
        description: "日流量数据",
        name: "今日流量"
      },
      traffic: {
        description: "流量报告",
        name: "流量"
      }
    },
    sales: {
      always_allow_delete: {
        description: "始终允许订单删除",
        name: "订单删除"
      },
      dailyreport: {
        description: "日结报告访问",
        fullreport: {
          description: "完整日结报告",
          name: "完整报告"
        },
        limited: {
          description: "有限日结报告",
          name: "有限"
        },
        name: "日结报告"
      },
      homedelivery: {
        assigntocourier: {
          description: "将家庭配送订单分配给快递员",
          name: "分配给快递员"
        },
        closeorders: {
          description: "关闭家庭配送订单",
          name: "关闭订单"
        },
        name: "家庭配送"
      },
      name: "销售",
      pickup: {
        closeorders: {
          description: "关闭取餐订单",
          name: "关闭订单"
        },
        description: "取餐订单管理",
        name: "取餐"
      },
      pointofsale: {
        name: "销售点",
        view: {
          name: "查看"
        }
      },
      printinvoice: {
        description: "发票打印权限",
        name: "发票打印"
      },
      registerpayment: {
        description: "支付注册权限",
        name: "支付注册"
      },
      revert: {
        description: "取消已支付/已关闭的订单",
        name: "取消"
      },
      settings: {
        description: "销售设置管理",
        name: "销售设置"
      },
      tablesoverview: {
        description: "桌面概览",
        modify: {
          name: "修改桌面布局"
        },
        name: "桌面布局",
        view: {
          name: "查看"
        }
      }
    },
    serving: {
      description: "服务区域",
      name: "服务"
    },
    stockmanagement: {
      barcodes: {
        add: {
          name: "添加"
        },
        delete: {
          name: "删除"
        },
        description: "条形码管理",
        modify: {
          name: "修改"
        },
        name: "条形码管理",
        view: {
          name: "查看"
        }
      },
      description: "库存管理系统",
      incomingstocks: {
        add: {
          name: "添加"
        },
        delete: {
          name: "删除"
        },
        description: "入库管理",
        modify: {
          name: "修改"
        },
        name: "入库",
        view: {
          name: "查看"
        }
      },
      inventories: {
        add: {
          name: "添加"
        },
        delete: {
          name: "删除"
        },
        description: "库存管理",
        modify: {
          name: "修改"
        },
        name: "库存",
        view: {
          name: "查看"
        }
      },
      inventorytemplates: {
        add: {
          name: "添加"
        },
        delete: {
          name: "删除"
        },
        description: "库存模板管理",
        modify: {
          name: "修改"
        },
        name: "库存模板",
        view: {
          name: "查看"
        }
      },
      inventoryscrapping: {
        add: {
          name: "添加"
        },
        delete: {
          name: "删除"
        },
        description: "库存报废管理",
        modify: {
          name: "修改"
        },
        name: "库存报废",
        view: {
          name: "查看"
        }
      },
      name: "库存管理",
      pandl: {
        description: "损益分析",
        name: "损益分析"
      },
      shoppinglist: {
        description: "购物清单管理",
        name: "购物清单"
      },
      stocklist: {
        description: "库存清单管理",
        name: "库存清单"
      },
      stockmovements: {
        add: {
          name: "添加"
        },
        delete: {
          name: "删除"
        },
        description: "库存移动管理",
        modify: {
          name: "修改"
        },
        name: "库存移动",
        view: {
          name: "查看"
        }
      },
      stockstatistics: {
        description: "库存统计报告",
        name: "库存统计"
      },
      stores: {
        add: {
          name: "添加"
        },
        delete: {
          name: "删除"
        },
        description: "仓库管理",
        modify: {
          name: "修改"
        },
        name: "仓库",
        view: {
          name: "查看"
        }
      },
      suppliers: {
        add: {
          name: "添加"
        },
        delete: {
          name: "删除"
        },
        description: "供应商管理",
        modify: {
          name: "修改"
        },
        name: "供应商",
        view: {
          name: "查看"
        }
      }
    },
    tablebooking: {
      book: {
        name: "新预订"
      },
      description: "桌面预订系统",
      name: "桌面预订",
      settings: {
        name: "设置"
      },
      "view:": {
        name: "打开"
      }
    },
    waiter: {
      description: "服务员屏幕访问",
      name: "服务员屏幕"
    }
  },
  restart_needed: "(重新)启动打印机",
  restart_printer: "请重启以下打印机: {0}",
  restart_printerserver: "重新连接打印机",
  restaurant: "餐厅",
  restaurant_editor: "餐厅",
  restaurant_properties_includedoptions: "配方 - 默认包含的配料",
  restaurant_properties_mandatoryoptions: "配方 - 必选配料",
  restaurant_properties_optionaloptions: "配方 - 可选选项",
  restaurant_settings: {
    default_language: "默认语言"
  },
  revert: "恢复",
  revert_payment: "您确定要恢复支付吗？",
  revert_table_mate_payment: "也恢复支付",
  revert_table_occupation: "您确定要恢复吗？",
  revert_table_occupation2: "您想对这笔订单做什么？",
  revert_table_occupation_multi_payment: "您确定要恢复吗？有多个付款人，支付可以在支付选项卡上恢复！",
  role: "角色",
  role_names: {
    admin: "管理员",
    cook: "厨师",
    courier: "快递员",
    finance: "财务",
    printerserver: "打印服务器",
    store: "库存管理员",
    tester: "测试员",
    waiter: "服务员"
  },
  roles: "角色",
  room: "房间",
  room_editor: "房间",
  room_tables: "{0} 张桌子",
  room_tables_seats: "{0} 张桌子，{1} 个座位",
  rotate_left: "左旋（45°）",
  rotate_right: "右旋（45°）",
  rounding: "四舍五入",
  sale: "销售",
  save: "保存",
  save_and_close: "保存并关闭",
  save_and_new: "保存并复制",
  save_and_open: "保存并测试",
  save_and_unlock: "支付并解锁",
  save_layout: "保存餐桌布局",
  save_my_details_for_later_use: "我同意我的个人数据由 {0} 和云餐厅管理系统 EatWithMe 存储和管理。",
  save_update_address: "保存并更新地址",
  saved_my_details_for_later_use: "我同意我的个人数据由 {0} 和云餐厅管理系统 EatWithMe 存储和管理。",
  scan_to_join_table: "!LF!ESC|cA!ESC|4CTable {0}!LF!LF!ESC|4C!ESC|cA扫描并下单！LF!ESC|cA并在线管理您的消费！",
  scan_to_pay_table: "用您的手机扫描\r\n查看桌号 {0} 的消费。\r\n并在线结账！",
  scanit: "这是您的收据吗？请扫描！",
  scope: "范围",
  scrapping: "报废",
  search_pattern: "搜索模式",
  seat: "座位",
  seat_types: {
    normal_chair: "普通椅子",
    wooden_chair: "木椅"
  },
  seats: "座位",
  secret_key: "密钥",
  select_a_category: "选择一个类别",
  select_a_product: "选择一个产品",
  select_a_quantity_type: "选择一个数量类型",
  select_a_supplier: "选择一个供应商",
  select_a_vat_category: "选择一个增值税类别",
  select_store: "选择仓库",
  selling_price: "毛销售价格",
  seqnr: "序列号",
  server_url: "广域网URL",
  service: "服务",
  service_fee: "服务费",
  service_fee_net: "净服务费",
  service_fee_vat: "分离的服务费",
  serving: "服务中",
  serving_type: "分装类型",
  sesame: "芝麻",
  settings: "设置",
  shareable: "可共享",
  short_name: "简称",
  shortage: "短缺",
  show_deleted: "显示已删除项目",
  sitting_at_table: "坐在桌号 {0}",
  skin_picker: "主题选择器",
  skins: [{ "id": "default", "name": "默认" }, { "id": "fancy", "name": "花哨" }, { "id": "flat", "name": "平面" }, { "id": "night", "name": "夜间" }, { "id": "old", "name": "老式" }],
  something_strange_happened_resync: "发生了意外情况! 正在重新同步...",
  sort_abc: "排序",
  source_and_target_store_should_be_different: "源商店和目标商店应不同",
  soybeans: "大豆",
  split_invoice: "拆分发票",
  stable_versions: "稳定版本",
  start_count: "预期数量",
  status: "状态",
  stock: "库存",
  stock_movement: "库存移动",
  stockAnalitics: "库存分析",
  store: "商店",
  stores: "仓库",
  storno: "冲销",
  stornoreason: "取消原因",
  stornoreason_0: "其他",
  stornoreason_1: "客户取消",
  stornoreason_2: "输入错误",
  stornoreason_3: "输入错误的支付方式",
  stornoreason_4: "产品缺货",
  stornoreason_5: "发票类型错误",
  stornoreason_6: "支付方式失败",
  stornoreason_7: "客户数据错误/输入错误",
  stornoreason_8: "测试购买",
  submit_and_accept_and_print_and_pay_new_orders: "支付",
  submit_and_accept_and_print_new_orders: "打印新订单",
  submit_and_accept_new_orders: "提交并接受新订单",
  submit_new_orders: "提交新订单",
  subscription: "订阅",
  sulfites: "亚硫酸盐",
  supplier: "供应商",
  supplier_code: "供应商代码",
  suppliers: "供应商",
  surplus: "过剩",
  suspend_ordering: "暂停点餐",
  syncronize_barcodes: "同步",
  table: "桌子",
  table_editor: "桌子编辑",
  table_extentions_placeholder: "+table_number=total_seats_count 例如 +4=8,+4+5=12",
  table_free_seats: "可用空闲座位",
  table_is_active: "桌子是激活的",
  table_is_shareable: "桌子是可共享的",
  table_number: "桌号: {0}",
  table_number_label: "桌号",
  table_occupation_number: "占用号: {0}",
  table_occupations: "桌面",
  table_ready_for_delivery: "!ESC|bC!ESC|4C桌号 {0}!LF!ESC|bC!ESC|4C订单号 {1}!LF!ESC|bC!ESC|4C{2}!LF!ESC|bC!ESC|4C送餐!",
  table_types: {
    circle_four_seats: "四座圆桌",
    person: "人",
    persons: "人",
    pool_table: "台球桌",
    rectangle_four_seats: "四座桌子",
    rectangle_six_seats: "六座桌子",
    rectangle_two_seats: "两座桌子",
    rounded_four_seats: "四座圆形桌子",
    rounded_six_seats: "六座圆形桌子"
  },
  tableOccupations: "桌面占用",
  tables: "桌子",
  tablesoverview: {
    tooltip: {
      printed: "打印成功。",
      printfailed: "打印尝试失败。请重新打印。",
      printing: "打印中",
      unprinted: "订单尚未打印。"
    }
  },
  takeaway: {
    containerChargeItem: {
      title: "押金产品标识符"
    },
    default: {
      description: "启用收银台的自动外卖",
      title: "默认"
    },
    enabled: {
      title: "启用"
    },
    packageChargeItem: {
      title: "包装产品标识符"
    },
    price: {
      description: "在产品页面上指定额外的外卖价格选项。",
      title: "单独外卖价格"
    },
    systemFeeItem: {
      title: "系统使用费产品标识符"
    },
    title: "外卖",
    vat: {
      title: "外卖默认增值税"
    }
  },
  takeaway_addition_tooltip: "适用于外卖或送货上门",
  takeaway_consumption: "外卖消费",
  takeawayConsumption: "外卖消费",
  tare_weight: "皮重",
  target_table_same_and_source: "目标桌与源桌相同！",
  tax_number: "税号",
  tax_number_pattern: "(^$)|(^\\d\\d\\d\\d\\d\\d\\d\\d-\\d-\\d\\d$)",
  team_number: "团队: {0}",
  terminal: "终端",
  test: "测试",
  test_mode: "测试模式",
  test_scale: "测试秤",
  test_system: "测试系统",
  test_versions: "测试版本",
  teya: {
    error: {
      CANCELLED: "银行卡支付已取消",
      CANCELLING: "正在取消银行卡支付",
      FAILED: "银行卡支付失败",
      NEW: "银行卡支付失败。终端无响应！",
      unknown: "银行卡支付失败"
    }
  },
  thanks_for_buying: "感谢购买",
  "The address.address field is required.": "地址不能为空。",
  "The address.address must be at least 2 characters.": "地址至少2个字符。",
  "The address.city field is required.": "城市不能为空。",
  "The address.city must be at least 2 characters.": "城市名称至少2个字符。",
  "The address.post code field is required.": "邮政编码不能为空。",
  "The device communications channel could not be opened, check the device and retry.": "打印机似乎已关闭或配置不正确。",
  "The name field is required.": "名称不能为空。",
  the_table_is_not_occupied: "这个桌子是空的！",
  there_already_exists_a_table_with_this_number: "您已经放置了这个桌号!",
  layout_must_remain_wider_than_tall: "布局必须保持宽度大于高度。",
  there_is_a_loop_in_the_additions: "菜单项之间存在引用循环！",
  this_month: "本月",
  this_quarter: "本季度",
  this_week: "本周",
  time: "时间",
  timetable: "营业时间",
  timing: "时间",
  timing_appetizer: "开胃菜",
  timing_asap: "尽快",
  timing_desert: "甜点",
  timing_inherit: "继承",
  timing_last: "最后",
  timing_maincourse: "主菜",
  timing_null: "",
  tip: "小费",
  tip_amount_seems_excesive: "金额似乎过高！继续吗？",
  to_store: "目标商店",
  to_whom: "适用对象",
  toDate: "结束日期",
  today: "今天",
  token: "令牌",
  tomorrow: "明天",
  too_many_bluetooth_cashiers: "í一次只能配对一个蓝牙收银机！",
  tooltip: {
    address: "请提供完整地址，例如：'Árpád köz 2.' 如果系统无法找到地址，系统将接受任何以 '/' 开头的地址，例如：'/在火车站入口处'",
    comment: "仅为此订单设置评论！",
    couriers: "可能的快递员（拥有快递员权限的用户）。此权限可以在管理系统中授予已注册的用户。",
    delivery_time: "计划交付时间",
    header_accepted_order: "订单已确认！您可以通过双击重新确认所有待处理或选中的订单！",
    header_filter_accepted_order: "筛选已确认的订单",
    header_filter_new_incoming_order: "筛选新订单",
    header_filter_order_assigned: "已分配给快递员的订单",
    header_filter_order_delivered: "筛选已交付的订单",
    header_filter_order_in_production: "筛选准备中的订单",
    header_filter_order_ready: "筛选已准备好的订单",
    header_filter_order_under_delivering: "筛选配送中的订单",
    header_new_incoming_order: "新订单待确认！",
    header_order_delivered: "订单已交付！您可以通过双击设置此状态应用到所有订单或选中的订单！",
    header_order_in_production: "订单准备中！您可以通过双击设置此状态应用到所有订单或选中的订单！",
    header_order_ready: "订单准备好！您可以通过双击设置此状态应用到所有订单或选中的订单！",
    header_order_under_delivering: "订单配送中！您可以通过双击设置此状态应用到所有订单或选中的订单！",
    header_print_invoice: "双击打印所有或选中订单的发票！",
    header_print_receipt: "双击打印所有未打印的订单或选中的订单！",
    print_all_labels: "双击打印所有标签！",
    header_unlock: "双击解锁或锁定所有可解锁（已交付并付款）订单！",
    link_courier: "双击将选中的订单分配给此快递员！",
    paid: "发票已支付。",
    pickup_time: "计划取件时间",
    print_invoice: "双击打印发票！",
    print_receipt: "双击打印订单！",
    printed: "打印成功！双击打印副本。",
    printfailed: "打印尝试失败。双击重新打印。",
    printing: "打印中",
    qrcode: "双击打印快递员的区块。",
    register_payment: "双击注册付款详情。",
    reprint_receipt: "双击重新打印订单！",
    set_accepted_order: "订单已确认！您可以通过双击再次确认订单！",
    set_new_incoming_order: "新订单待确认！",
    set_order_delivered: "订单已交付！您可以通过双击设置此状态！",
    set_order_in_production: "订单准备中！您可以通过双击设置此状态！",
    set_order_ready: "订单准备好！您可以通过双击设置此状态！",
    set_order_under_delivering: "订单配送中！您可以通过双击设置此状态！",
    unlink_courier: "双击从快递员处移除订单！",
    unlock: "双击解锁或锁定订单！",
    unprinted: "订单尚未打印。双击打印。",
    user_comment: "为您的客户设置永久性评论。此评论将在下次订单中显示！"
  },
  tooltip_label_count: "使用标签打印机时，为此产品打印的标签数量",
  tooltip_notprinted: "尚未打印！",
  tooltip_partprinted: "打印错误！正在重新尝试打印！",
  tooltip_printed: "已打印",
  tooltip_printfailed: "打印错误！",
  tooltip_printing: "打印进行中！",
  top_category: "顶级分类",
  total: "总计",
  total_incoming_stock_entries: "<span>{0}</span> <span class='browser-only'> 总记录数</span>",
  total_stock_cost: "库存购买价值",
  total_stock_value: "库存销售价值",
  total_value_difference: "总价值差异",
  town: "城镇",
  traffic: "流量",
  type: "类型",
  typical_rejection_reasons: "典型拒绝原因",
  ui: {
    addResource: "添加资源",
    addRole: "添加角色",
    cancel: "取消",
    close: "关闭",
    delete: "删除",
    deleteResources: "删除资源",
    description: "描述",
    descriptionLabel: "描述：",
    newResource: "新资源",
    permission: "权限",
    permissionName: "权限名称：",
    resource: "资源",
    resourceName: "资源名称：",
    role: "角色",
    roleName: "角色名称：",
    save: "保存"
  },
  unassigned_orders: "未分配订单",
  uncategorized_items: "没有设置类别的产品",
  unit_of_consumption: "销售/使用单位",
  unit_price: "单价",
  unit_price_estimation: "建议单价",
  unknown_person_pays: "人员 {0} 支付",
  unlock: "解锁",
  unoccupy: "释放",
  until_when_delete_the_traffic: "您希望删除直到哪一天的流量（格式：YYYY-MM-DD）",
  updateBookingNotSuccessful: "客户数据保存失败",
  upload: "上传",
  upload_barcodes: "上传",
  upload_successful: "上传成功",
  user: "用户",
  user_comment: "其他客人信息",
  user_missing: "未注册该电子邮件地址的用户",
  users: "用户",
  value_difference: "价值差异",
  vat: "增值税",
  vat_categories: "增值税类别",
  vat_category: "增值税类别",
  vat_category_editor: "增值税类别编辑",
  vat_category_name: "增值税类别名称",
  vat_invoice: "增值税发票",
  view: "查看",
  visible_online: "对客人可见",
  "voipphone-Registration failed:Authentication Error": "注册失败：认证错误",
  "voipphone-undefined": "离线",
  waiterOrder: "服务员订单",
  webshop: "网上商店",
  webshop_order_fee: "网上商店订单系统使用费",
  webshopOrder: "网上商店订单",
  week: "周",
  when: "时间",
  withdraw: "撤回",
  without_allergen: "{0} 无过敏原",
  wolt: {
    delete_category: "从 Wolt 删除产品类别",
    delete_category_items: "删除仅在此类别下存在的 Wolt 产品",
    delete_menu_item: "从 Wolt 删除产品",
    delete_menu_items: "从 Wolt 删除产品",
    delete_selected_elements: "从 Wolt 删除选定的产品",
    elements_in_sync: "同步中的产品数量",
    elements_in_to_delete: "Wolt 上的多余产品数量",
    elements_in_to_upload: "缺少的产品数量",
    elements_in_unsync: "未同步的产品数量",
    reload: "从 Wolt 刷新",
    resync_selected_elements: "重新同步选定的产品到 Wolt",
    sync_category_items: "重新同步在 EatWithMe 和 Wolt 中均已存在的产品",
    sync_menu_item: "同步产品到 Wolt",
    upload_category: "上传产品类别到 Wolt",
    upload_category_items: "上传缺少的产品到 Wolt",
    upload_menu_item: "上传产品到 Wolt",
    upload_selected_elements: "上传选定的产品到 Wolt"
  },
  yearsAgo: "{0}年前",
  yes: "是",
  yesterday: "昨天",
  "You do not have subscription for this operation": "您没有此操作的订阅",
  you_are_not_authorized_to_access_this_feature: "根据您的订阅，您无法访问此功能。",
  you_are_not_authorized_to_access_this_restaurant_with_an_app: "根据您的订阅，您无法访问此单位。",
  you_cannot_order_so_many: "您不能一次性订购<strong>{0}</strong>件！",
  you_need_admin_right_for_this_action: "您需要管理员权限来执行此操作！",
  CLEAR_PRODUCT: '清除产品',
  ADD_MISSING_PRODUCT: '添加缺失产品',
  CLEAR_QUANTITY_TYPE: '清除数量类型',
  CLEAR_VAT_CATEGORY: '清除增值税类别',
  CLEAR_STORE: '清除仓库',
  VALIDATION_SUCCESS: '所有验证检查通过',
  SEARCH_PRODUCTS: '输入以搜索产品...',
  SEARCH_QUANTITY_TYPES: '输入以搜索数量类型...',
  SEARCH_VAT_CATEGORIES: '输入以搜索增值税类别...',
  SEARCH_STORES: '输入以搜索仓库...',
  enter_invoice_id: '请输入发票号码',
  enter_delivery_note_id: '请输入送货单号码',
  cannotSave: '由于存在错误，无法保存',
  select_vat_category: '选择增值税类别',
  select_a_store: '选择仓库',
  query_invoice_data: '从NAV ONLINE-SZAMLA系统查询发票数据',
  failed_to_query_invoice_data: '从NAV ONLINE-SZAMLA系统查询发票数据失败',
  delete_user_confirm: "您确定要删除此用户吗？",
  delete_role_confirm: "您确定要删除此角色吗？",
  upload_menu: "上传菜单",
  connect_choiceqr: "连接到 ChoiceQR",
  choiceqr_connect_token_info: "在 ChoiceQR 窗口中，您需要使用以下令牌（代码）来授权连接。请先复制，然后打开 ChoiceQR 页面。",
  choiceqr_copy: "复制到剪贴板",
  choiceqr_copied: "已复制",
  choiceqr_open_connect: "打开 ChoiceQR",
  choiceqr_connected: "ChoiceQR 已连接。",
  choiceqr_waiting: "正在等待连接完成...",
  choiceqr_missing_domain_or_client: "请先在设置中填写域名和 clientId。",
  connect_wolt_instance: "连接 Wolt 账户",
  connect_button: "连接到 Wolt",
  code_received: "授权代码已接收！",
  error: "错误： {0}",
  sync_superset: "Superset 同步",
  invalid_barcode_gross_tare_weight: "毛重必须大于皮重！",
  storno_payment_method: "退款支付方式",
  refund_payment_method: "退款支付方式",
  card: "银行卡",
  cash: "现金",
  cash_return_calculation: "找零计算",
  cash_return_calculation_help: "启用后，只有当现金支付金额大于0且现金输入框有焦点时才会显示现金面额。点击面额可设置收到的现金金额。系统会根据这些值自动计算找零。",
  storno_quantity: "冲销数量",
  return_and_refund: "退货和退款",
  refundreason_1: "有缺陷的产品 / 错误的产品",
  refundreason_2: "客户取消购买",
  refundreason_3: "其他原因",
  VATInvoice: "增值税发票",
  preorder: "预订",
  automation: {
    id: "ID",
    name: "名称",
    menu_item: "菜单项",
    menu_category: "菜单类别",
    optional_category_options: "可选类别选项",
    optionType: "选项类型",
    proportional: "按比例",
    context: "上下文"
  },
  drive: {
    check_for_wolt_delivery: "检查Wolt配送",
    wolt_drive_delivery_time: "计划的Wolt配送时间",
    wolt_drive_price: "Wolt配送价格",
    wolt_drive_no_info: "没有关于Wolt配送条件的信息",
    wolt_drive_reason: "Wolt配送条件未满足，因为",
    "Dropoff location is outside the delivery area": "收货地点在配送区域之外",
    "Dropoff location is outside of the delivery area": "收货地点在配送区域之外",
    delivery_with_wolt_courier: "由Wolt快递员配送",
    wolt_courier: "Wolt快递员",
    "Request made outside delivery hours": "请求在配送时间之外",
    "Delivery area is closed": "配送区域已关闭",
    "Delivery area will be closed at the requested delivery time": "配送区域将在请求的配送时间关闭",
    "already_received_cannot_reassign": "订单已被Wolt快递员确认，无法重新分配给新快递员",
    "already_received_cannot_delete": "订单已被Wolt快递员确认，无法删除快递员订单",
    "Value error, Invalid phone number: (1) The string supplied did not seem to be a phone number": "值错误，电话号码无效：提供的字符串似乎不是电话号码",
    "Value error, 'name' can not be empty": "值错误，‘姓名’不能为空",
    "Order is not in a rejectable state. Please contact support to cancel it": "订单不可取消。请联系支持取消订单",
    already_assigned_to_wolt_courier: "您已为此订单分配了Wolt快递员",
    earliest_delivery_time: "最早的配送时间是 %{time}，而不是 %{originaltime} %{fromNow}",
  },
  contact_email: "联系邮箱",
  website_url: "网站网址",
  login_in_progress: "登录进行中...",
  deleted_by: "已删除",
  not_bound_to_table: "未绑定到桌子",
  no_epd: "未选择桌面显示",
  pairing_code: "配对码",
  pair: "配对",
  promotional_price: "促销价",
  enter_promotional_price: "促销价",
  enter_promotion_name: "促销名称",
  enter_promotional_start_date: "请输入促销开始日期",
  enter_promotional_end_date: "请输入促销结束日期",
  promotion_name: "促销名称",
  promotional_start_date: "促销开始",
  promotional_end_date: "促销结束",
  promotion_price: "促销价",
  promotion: "促销",
  promotions: "促销活动",
  differences_in_promotionName: "促销名称差异",
  differences_in_promotionPrice: "促销价格差异",
  differences_in_promotionStart: "促销开始日期差异",
  differences_in_promotionEnd: "促销结束日期差异",
  old: "旧",
  permanent_delete: "永久删除",
};
export default admin_local_cn;
